import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { CATALOG, SEOI18N } from "./i18n-catalog";
import PAGES_EXTRA from "./lib/ui-i18n/pages-extra.json";
import DEALER_I18N from "./lib/ui-i18n/dealer.json";
import QA_FOOTER_EXTRA from "./lib/ui-i18n/qa-footer-extra.json";
import LEGAL_EN from "./lib/ui-i18n/legal-en.json";
import LEGAL_ES from "./lib/ui-i18n/legal-es.json";
import LEGAL_IT from "./lib/ui-i18n/legal-it.json";
import LEGAL_DE from "./lib/ui-i18n/legal-de.json";
import LEGAL_PT from "./lib/ui-i18n/legal-pt.json";
import LEGAL_FR from "./lib/ui-i18n/legal-fr.json";
import FR_EXTRA from "./lib/ui-i18n/fr-extra.json";
import LEGAL_NL from "./lib/ui-i18n/legal-nl.json";
import NL_EXTRA from "./lib/ui-i18n/nl-extra.json";
import LEGAL_RU from "./lib/ui-i18n/legal-ru.json";
import RU_EXTRA from "./lib/ui-i18n/ru-extra.json";
import LEGAL_LT from "./lib/ui-i18n/legal-lt.json";
import LT_EXTRA from "./lib/ui-i18n/lt-extra.json";
import { CORPORATE } from "./i18n-corporate";

export const LANGS = [
  { code: "en", label: "English", flag: "EN" },
  { code: "es", label: "Español", flag: "ES" },
  { code: "it", label: "Italiano", flag: "IT" },
  { code: "de", label: "Deutsch", flag: "DE" },
  { code: "pt", label: "Português", flag: "PT" },
  { code: "fr", label: "Français", flag: "FR" },
  { code: "nl", label: "Nederlands", flag: "NL" },
  { code: "ru", label: "Русский", flag: "RU" },
  { code: "lt", label: "Lietuvių", flag: "LT" },
];

export const RTL_LANGS = ["ar"];

const resources = {
  en: {
    translation: {
      fd: { leaving: "You are leaving VANROCK Track Solutions", headline: "Largest Range of Final Drives in the World", body: "Final drives live on our dedicated online store, VANROCK Drives — with instant stock availability, quotes, parts lists and worldwide shipping across thousands of machine models.", continue: "Continue to the site", stay: "Stay here" },
      ext: { groupHeadline: "The corporate home of VANROCK", groupBody: "You are heading to the VANROCK Group corporate website — the group's companies, divisions and global operations in one place." },
      nav: {
        quote: "Get Quote",
        brands: "Brands",
        search: "Part Search",
        products: "Product Groups",
        productsLine: "Every undercarriage wear part, organized by component.",
        company: "Company",
        searchPlaceholder: "SEARCH: BRAND MODEL PART",
        insights: "Company information and insights",
      },
      footer: {
        blurb:
          "<0>VANROCK Track Solutions</0> is the undercarriage division of <1>VANROCK Group</1> — a heavy equipment manufacturer engineering high-performance construction attachments: crusher buckets, screening buckets, rock breakers, drum cutters and rock saws — trusted on construction, mining and quarrying sites worldwide.",
        visitGlobal: "Visit our global website — vanrockglobal.com ↗",
        tagline: "Undercarriage parts. Built to last.",
        catalog: "Catalog",
        company: "Company",
        contact: "Contact",
        allBrands: "All Brands",
        partSearch: "Part Search",
        becomeDealer: "Become a Dealer →",
        rights: "All rights reserved",
        admin: "Admin Access",
      },
      home: {
        kicker: "A",
        kickerCompany: "brand",
        h1a: "Find the exact",
        h1b: "undercarriage",
        h1c: "part.",
        heroSub:
          "Track rollers, carrier rollers, sprocket segments, track chains, shoes, bolts and nuts — covering {{brands}} brands and {{models}} machine models.",
        searchBtn: "Search",
        try: "Try:",
        statBrands: "Brands",
        statModels: "Models",
        statParts: "Parts",
        browseKicker: "Browse Catalog",
        brandIndex: "Brand index",
        allN: "All {{n}} →",
        modelsWord: "MODELS",
        topBrands: "Most catalogued brands",
        azBrands: "All brands A–Z",
        browseAz: "Browse all {{n}} brands A–Z",
        compKicker: "Components",
        compTitle: "Every undercarriage component",
        compView: "View catalog →",
        compDesc: {
          "track-roller":
            "Track rollers run along the underside of the track frame and carry the full weight of the machine on the chain rail. Available as single and double flange, with sealed, lifetime-lubricated assemblies.",
          "carrier-roller":
            "Carrier rollers support the upper run of the track chain and keep it aligned between the idler and the sprocket, preventing sag and side wear.",
          idler:
            "The idler guides the track chain at the front of the track frame and works together with the tensioning unit to keep the chain at the correct tension.",
          sprocket:
            "The sprocket engages the chain bushings and transfers drive power to the track. Sprockets mount directly on the final drive; segment groups are bolted and can be replaced without splitting the chain.",
          "track-chain":
            "The track chain is the backbone of the undercarriage: links, pins and bushings that transfer the machine weight to the shoes. Available as sealed & lubricated or dry versions.",
          "track-shoe":
            "Track shoes bolt onto the chain links and form the machine's contact surface with the ground. Grouser height and shoe width determine traction and ground pressure.",
          "track-group":
            "A track group is a complete assembly of track chain and mounted shoes — ready to install on the machine as a single unit.",
          "rubber-track":
            "Rubber tracks combine internal steel cords and metal cores with a rubber tread — for mini excavators and compact machines working on surfaces that steel tracks would damage.",
          "track-bolt-nut":
            "Track bolts and nuts fasten the shoes to the chain links. Hardened fasteners with a defined tightening torque, sized per shoe and chain type.",
          "rubber-pad":
            "Rubber pads let steel-tracked machines work on asphalt, concrete and finished surfaces without damage. Each pad is individually vulcanised onto a metal core — available as bolt-on, chain-on, clip-on and road versions, sized by chain link pitch.",
        },
        rp: {
          sysKicker: "MOUNTING SYSTEMS",
          vname: {
            "bolt-on": "Bolt-on rubber pads",
            "chain-on": "Chain-on rubber pads",
            "hd-vgrip": "Heavy Duty chain-on rubber pads",
            "clip-on": "Clip-on rubber pads",
            road: "Road pads",
          },
          vdesc: {
            "bolt-on":
              "Screwed onto the track shoes through additional holes in the shoe. VANROCK supplies track shoes pre-drilled for bolt-on pads as a complete solution.",
            "chain-on":
              "Mounted directly on the track chain — the machine runs on rubber without track shoes.",
            "hd-vgrip":
              "More wear-resistant than standard chain-on pads.",
            "clip-on":
              "Clamped around the fitted track shoe. Shoe profiles differ between manufacturers — measure your shoe before ordering; clip-on pads always fit VANROCK track shoes.",
            road: "Flat pads for road transport duty: rubber for grip, or polyurethane poured directly onto the shoe — extremely wear-resistant and resistant to oils, petrol and grease.",
          },
          colCode: "Product code",
          colPitch: "Link pitch",
          colMaterial: "Material",
          mm: "All dimensions in mm",
          withHw: "Supplied with bolts and nuts",
          quote: "Get a quote →",
          dimRef: "Dimension reference",
          refLine:
            "{{count}} pad references across {{variants}} mounting systems — request a quote with your VANROCK code.",
          matPoly: "Polyurethane",
          matRubber: "Rubber",
        },
        f1t: "OEM specification",
        f1x: "Boron & alloy steel, deep-hardened wear surfaces, sealed and lubricated for life.",
        f2t: "Fast worldwide delivery",
        f2x: "Parts dispatched from stock. Delivery quotes included with every offer.",
        f3t: "Free technical support",
        f3x: "Send us your serial number and our specialists will match the exact part.",
        dealerKicker: "Dealer Program",
        dealerT1: "Put",
        dealerT2: "on your shelf.",
        dealerSub:
          "Consistent quality, deep stock and direct manufacturer pricing — everything a dealer needs to win their market. Join the VANROCK dealer network in your territory.",
        dp1: "+ Direct manufacturer pricing",
        dp2: "+ Territory protection",
        dp3: "+ Marketing support",
        dp4: "+ Priority stock allocation",
        dealerCta: "Become a dealer →",
        faqKicker: "FAQ",
        faqTitle: "Frequently asked questions",
        faq1q: "Which machinery brands do you cover?",
        faq1a:
          "We stock undercarriage parts for 350+ brands including Caterpillar, Komatsu, Kobelco, Hitachi, Volvo, JCB, Hyundai, Doosan, Case, Liebherr, Takeuchi, Yanmar, Kubota and many more.",
        faq2q: "How do I find parts for my machine?",
        faq2a:
          "Select your machinery brand, then pick your exact model from the alphabetical list. Every model page lists all available undercarriage components: rollers, sprocket segments, track chains, shoes, bolts and nuts.",
        faq3q: "How do I get pricing?",
        faq3a:
          "Open any part page and submit the Request a Quote form. Our team responds with pricing and availability.",
        faq4q: "Are the parts OEM quality?",
        faq4a:
          "All parts are manufactured to OEM specifications from boron and alloy steels, with deep-hardened wear surfaces and sealed, lifetime-lubricated assemblies where applicable.",
      },
      company: {
        h1a: "Built for the world's",
        h1b: "toughest ground.",
        heroSub:
          "VANROCK Track Solutions is the undercarriage division of VANROCK Group — engineering, forging and machining track systems for the world's leading machinery brands, and supplying dealers and fleets worldwide.",
        visitGlobal: "Visit our global website ↗",
        s1: "Machinery brands covered",
        s2: "Parts engineered & catalogued",
        s3: "Machine models supported",
        s4: "Quality inspected before dispatch",
        madeKicker: "Made In VANROCK",
        madeT1: "Engineered, forged and",
        madeT2: "finished in-house.",
        madeT3: "End-to-end control.",
        madeSub:
          "Our manufacturing operations are vertically integrated across the full production cycle — forging, casting and stamping, precision machining, heat treatment and track chain assembly. Sustained investment in process automation gives us direct oversight of quality and supply continuity at every stage, while a dedicated research and development program drives the ongoing expansion of our product range — engineered to perform, priced to compete, and aligned with the demands of a changing market.",
        mp1: "In-house forging, machining & heat treatment",
        mp2: "100% quality inspection before dispatch",
        mp3: "OEM-spec materials, traceable to source",
        mp4: "Direct manufacturer pricing — no middlemen",
        whKicker: "Global Warehouse",
        whT1: "Global inventory.",
        whT2: "Immediate availability.",
        whSub:
          "Our warehouses hold thousands of rollers, idlers, chains and shoes in permanent stock, prepared for worldwide dispatch as soon as an order is confirmed.",
        mapKicker: "Global Presence",
        mapTitle: "One brand. Every continent.",
        mapDesc: "VANROCK operates through four regional offices in Munich, Fort Worth, Dandenong and Ludhiana — supporting dealers across Europe, North America, Australia and Asia with local contacts, local time zones and one shared inventory network.",
        mapSub:
          "VANROCK parts run on machines across construction and mining sites worldwide — supplied through our dealer network and direct exports.",
        ms1: "Countries served",
        ms2: "Continents",
        ms3: "Quote response",
        ms4: "Worldwide shipping",
        galKicker: "Inside VANROCK",
        galTitle: "Warehouse",
        teamKicker: "Our People",
        teamTitle: "One team. One standard.",
        teamSub: "Behind every VANROCK component is a team of engineers, production specialists and dealer support staff working to the same standard — in the plant and in the field.",
        factsTitle: "Facts & figures",
        scroll: "Scroll →",
      },
      dealer: {
        heroT1: "Become a",
        heroT2: "dealer.",
        heroSub:
          "The complete VANROCK undercarriage range — from track chains and rollers to rubber tracks and pads — is sold through a protected dealer network. If you distribute undercarriage parts in your market, or want to start, this program was built for you.",
        b1t: "Direct manufacturer pricing",
        b1x: "Buy directly from VANROCK — no middlemen, no markups. Dealers buy at true manufacturer rates.",
        b2t: "Territory protection",
        b2x: "We limit the number of dealers per region so your investment in the VANROCK brand is protected.",
        b3t: "Priority stock allocation",
        b3x: "Dealers get first access to production runs and reserved stock on fast-moving undercarriage parts.",
        b4t: "Marketing support",
        b4x: "Co-branded catalogs, product data sheets, photography and launch support for your local market.",
        b5t: "Consolidated shipping",
        b5x: "Parts delivered straight to your doorstep. VANROCK handles all shipping, customs and duties — making it as easy as ordering online.",
        b6t: "Global network",
        b6x: "Join dealers across construction and mining markets backed by the VANROCK Group.",
        howKicker: "How It Works",
        howTitle: "From application to first shipment",
        st1t: "Apply",
        st1x: "Fill in the registration form below with your company details and target territory.",
        st2t: "Review",
        st2x: "Our dealer team reviews your application and market fit — typically within 2 business days.",
        st3t: "Agreement",
        st3x: "We agree on territory, pricing tier and first stock order together with your dedicated manager.",
        st4t: "Launch",
        st4x: "You receive catalogs, marketing assets and your first shipment — and start selling VANROCK.",
        regKicker: "Registration",
        regTitle: "Dealer registration",
        regSub:
          "Fields marked * are required. Our dealer team replies within 2 business days.",
        lCompany: "Company name *",
        lContact: "Contact person *",
        lEmail: "Email *",
        lPhone: "Phone *",
        lCountry: "Country *",
        lCity: "City / region",
        lWebsite: "Company website",
        lType: "Business type",
        lYears: "Years in business",
        lVolume: "Expected monthly volume",
        lBrands: "Machine brands you serve",
        lMessage: "Tell us about your market",
        selectCountry: "Select country…",
        select: "Select…",
        submit: "Submit application →",
        submitting: "Submitting…",
        okTitle: "Application received.",
        okText:
          "Thank you. Our dealer team will review your application for {{country}} and contact you at {{email}} within 2 business days.",
      },
      chat: {
        teaser:
          "Need help finding the right part? Ask me — I know all 48,000+ parts.",
        status: "Online — replies in seconds",
        headerStatus: "Parts expert — replies in seconds",
        q1: "Find parts for my machine",
        q1h: "e.g. CAT 320, Komatsu PC200",
        q2: "Ask about pricing",
        q2h: "Commercial terms & availability",
        q3: "How do I get a quote?",
        q3h: "Fast response from sales",
        hi: "Hi, I'm your parts expert.",
        hiSub:
          "Tell me your machine brand and model — I'll find the right parts and help you get a quote.",
        placeholder: "e.g. Track chain for CAT D6D…",
        nowShowing: "Now showing:",
      },
    },
  },
  de: {
    translation: {
      fd: { leaving: "Sie verlassen VANROCK Track Solutions", headline: "Das größte Fahrantrieb-Sortiment der Welt", body: "Fahrantriebe finden Sie in unserem eigenen Online-Shop VANROCK Drives — mit sofortiger Verfügbarkeit, Angeboten, Teilelisten und weltweitem Versand für Tausende Maschinenmodelle.", continue: "Weiter zur Website", stay: "Hier bleiben" },
      ext: { groupHeadline: "Die Unternehmenszentrale von VANROCK", groupBody: "Sie werden zur Unternehmenswebsite der VANROCK Group weitergeleitet — alle Unternehmen, Geschäftsbereiche und weltweiten Aktivitäten der Gruppe an einem Ort." },
      nav: {
        quote: "Angebot",
        brands: "Marken",
        search: "Teile Suche",
        products: "Produktgruppen",
        productsLine:
          "Jedes Fahrwerks-Verschleißteil, geordnet nach Komponente.",
        company: "Unternehmen",
        searchPlaceholder: "SUCHE: MARKE MODELL TEIL",
        insights: "Unternehmensinformationen und Einblicke",
      },
      footer: {
        blurb:
          "<0>VANROCK Track Solutions</0> ist die Fahrwerkssparte von <1>VANROCK Group</1> — einem Hersteller von Schwermaschinen und leistungsstarken Anbaugeräten für die Bauindustrie: Backenbrecherlöffel, Sieblöffel, Hydraulikhämmer, Anbaufräsen und Felssägen — weltweit im Einsatz auf Baustellen, im Bergbau und in Steinbrüchen.",
        visitGlobal:
          "Besuchen Sie unsere globale Website — vanrockglobal.com ↗",
        tagline: "Fahrwerksteile. Gebaut für die Ewigkeit.",
        catalog: "Katalog",
        company: "Unternehmen",
        contact: "Kontakt",
        allBrands: "Alle Marken",
        partSearch: "Teilesuche",
        becomeDealer: "Händler werden →",
        rights: "Alle Rechte vorbehalten",
        admin: "Admin Zugang",
      },
      home: {
        kicker: "Eine",
        kickerCompany: "Marke",
        h1a: "Finden Sie das exakte",
        h1b: "Fahrwerks-",
        h1c: "teil.",
        heroSub:
          "Laufrollen, Tragrollen, Kettenradsegmente, Ketten, Bodenplatten, Schrauben und Muttern — für {{brands}} Marken und {{models}} Maschinenmodelle.",
        searchBtn: "Suchen",
        try: "Z.B.:",
        statBrands: "Marken",
        statModels: "Modelle",
        statParts: "Teile",
        browseKicker: "Katalog Durchsuchen",
        brandIndex: "Markenindex",
        allN: "Alle {{n}} →",
        modelsWord: "MODELLE",
        topBrands: "Meistkatalogisierte Marken",
        azBrands: "Alle Marken A–Z",
        browseAz: "Alle {{n}} Marken von A–Z ansehen",
        compKicker: "Komponenten",
        compTitle: "Jede Fahrwerkskomponente",
        compView: "Zum Katalog →",
        compDesc: {
          "track-roller":
            "Laufrollen laufen an der Unterseite des Laufwerksrahmens und tragen das gesamte Maschinengewicht auf der Kettenlauffläche. Erhältlich mit Einfach- oder Doppelbund, abgedichtet und lebensdauergeschmiert.",
          "carrier-roller":
            "Tragrollen stützen den oberen Kettenstrang und halten ihn zwischen Leitrad und Antriebsrad ausgerichtet — gegen Durchhang und seitlichen Verschleiß.",
          idler:
            "Das Leitrad führt die Kette an der Vorderseite des Laufwerksrahmens und hält zusammen mit der Spanneinheit die korrekte Kettenspannung.",
          sprocket:
            "Das Antriebsrad greift in die Kettenbuchsen und überträgt die Antriebskraft auf die Kette. Antriebsräder sitzen direkt am Endantrieb; Segmente sind verschraubt und lassen sich ohne Öffnen der Kette tauschen.",
          "track-chain":
            "Die Gleiskette ist das Rückgrat des Fahrwerks: Glieder, Bolzen und Buchsen, die das Maschinengewicht auf die Bodenplatten übertragen. Erhältlich abgedichtet und geschmiert oder trocken.",
          "track-shoe":
            "Bodenplatten werden an die Kettenglieder geschraubt und bilden die Kontaktfläche der Maschine zum Boden. Stollenhöhe und Plattenbreite bestimmen Traktion und Bodendruck.",
          "track-group":
            "Eine komplette Raupenkette ist eine fertige Einheit aus Gleiskette und montierten Bodenplatten — einbaufertig als ein Bauteil.",
          "rubber-track":
            "Gummiketten kombinieren innenliegende Stahlseile und Metallkerne mit einer Gummilauffläche — für Minibagger und Kompaktmaschinen auf Untergründen, die Stahlketten beschädigen würden.",
          "track-bolt-nut":
            "Kettenschrauben und -muttern befestigen die Bodenplatten an den Kettengliedern. Gehärtete Verbindungselemente mit definiertem Anzugsmoment, ausgelegt nach Platten- und Kettentyp.",
          "rubber-pad":
            "Gummipads ermöglichen Maschinen mit Stahlketten das Arbeiten auf Asphalt, Beton und befestigten Flächen ohne Schäden. Jedes Pad ist einzeln auf einen Metallkern vulkanisiert — als Bolt-on-, Chain-on-, Clip-on- und Straßenpad-Version, dimensioniert nach Kettenteilung.",
        },
        rp: {
          sysKicker: "MONTAGESYSTEME",
          vname: {
            "bolt-on": "Bolt-on-Gummipads",
            "chain-on": "Chain-on-Gummipads",
            "hd-vgrip": "Heavy-Duty-Chain-on-Gummipads",
            "clip-on": "Clip-on-Gummipads",
            road: "Straßenpads",
          },
          vdesc: {
            "bolt-on":
              "Werden durch zusätzliche Bohrungen in der Bodenplatte verschraubt. VANROCK liefert Bodenplatten mit Bohrungen für Bolt-on-Pads als Komplettlösung.",
            "chain-on":
              "Werden direkt auf der Gleiskette montiert — die Maschine läuft ohne Bodenplatten auf Gummi.",
            "hd-vgrip":
              "Verschleißfester als Standard-Chain-on-Pads.",
            "clip-on":
              "Werden um die montierte Bodenplatte geklemmt. Plattenprofile unterscheiden sich je nach Hersteller — Platte vor der Bestellung vermessen; Clip-on-Pads passen immer auf VANROCK Bodenplatten.",
            road: "Flache Pads für Straßenfahrten: Gummi für mehr Grip oder Polyurethan, direkt auf die Platte gegossen — extrem verschleißfest und beständig gegen Öle, Benzin und Fett.",
          },
          colCode: "Produktcode",
          colPitch: "Kettenteilung",
          colMaterial: "Material",
          mm: "Alle Maße in mm",
          withHw: "Lieferung inklusive Schrauben und Muttern",
          quote: "Angebot anfordern →",
          dimRef: "Maßreferenz",
          refLine:
            "{{count}} Pad-Referenzen in {{variants}} Montagesystemen — Angebot mit Ihrem VANROCK-Code anfordern.",
          matPoly: "Polyurethan",
          matRubber: "Gummi",
        },
        f1t: "OEM-Spezifikation",
        f1x: "Bor- und legierter Stahl, tiefgehärtete Verschleißflächen, dauergeschmiert und abgedichtet.",
        f2t: "Schnelle weltweite Lieferung",
        f2x: "Teile ab Lager. Lieferangebot bei jeder Offerte inklusive.",
        f3t: "Kostenloser technischer Support",
        f3x: "Senden Sie uns Ihre Seriennummer — unsere Spezialisten finden das exakte Teil.",
        dealerKicker: "Händler Programm",
        dealerT1: "Holen Sie",
        dealerT2: "in Ihr Regal.",
        dealerSub:
          "Konstante Qualität, tiefe Lagerbestände und direkte Herstellerpreise — alles, was ein Händler braucht. Werden Sie Teil des VANROCK-Händlernetzes in Ihrer Region.",
        dp1: "+ Direkte Herstellerpreise",
        dp2: "+ Gebietsschutz",
        dp3: "+ Marketing-Unterstützung",
        dp4: "+ Bevorzugte Lagerzuteilung",
        dealerCta: "Händler werden →",
        faqKicker: "FAQ",
        faqTitle: "Häufig gestellte Fragen",
        faq1q: "Welche Maschinenmarken decken Sie ab?",
        faq1a:
          "Wir führen Fahrwerksteile für 350+ Marken, darunter Caterpillar, Komatsu, Kobelco, Hitachi, Volvo, JCB, Hyundai, Doosan, Case, Liebherr, Takeuchi, Yanmar, Kubota und viele mehr.",
        faq2q: "Wie finde ich Teile für meine Maschine?",
        faq2a:
          "Wählen Sie Ihre Maschinenmarke und dann Ihr genaues Modell aus der alphabetischen Liste. Jede Modellseite listet alle verfügbaren Fahrwerkskomponenten auf.",
        faq3q: "Wie erhalte ich Preise?",
        faq3a:
          "Öffnen Sie eine Teileseite und senden Sie das Angebotsformular ab. Unser Team antwortet mit Preis und Verfügbarkeit.",
        faq4q: "Sind die Teile in OEM-Qualität?",
        faq4a:
          "Alle Teile werden nach OEM-Spezifikationen aus Bor- und legierten Stählen gefertigt, mit tiefgehärteten Verschleißflächen und dauergeschmierten Baugruppen.",
      },
      company: {
        h1a: "Gebaut für die härtesten",
        h1b: "Böden der Welt.",
        heroSub:
          "VANROCK Track Solutions ist die Fahrwerkssparte von VANROCK Group — wir entwickeln, schmieden und bearbeiten Kettensysteme für die führenden Maschinenmarken der Welt und beliefern Händler und Flotten weltweit.",
        visitGlobal: "Globale Website besuchen ↗",
        s1: "Maschinenmarken abgedeckt",
        s2: "Teile konstruiert & katalogisiert",
        s3: "Maschinenmodelle unterstützt",
        s4: "Qualitätsgeprüft vor Versand",
        madeKicker: "Made In VANROCK",
        madeT1: "Entwickelt, geschmiedet und",
        madeT2: "gefertigt im eigenen Werk.",
        madeT3: "Kontrolle von Anfang bis Ende.",
        madeSub:
          "Unsere Fertigung ist über den gesamten Produktionszyklus vertikal integriert — Schmieden, Gießen und Stanzen, Präzisionszerspanung, Wärmebehandlung und Kettenmontage. Kontinuierliche Investitionen in die Prozessautomatisierung sichern uns auf jeder Stufe die direkte Kontrolle über Qualität und Lieferkontinuität, während ein eigenes Forschungs- und Entwicklungsprogramm den stetigen Ausbau unseres Produktprogramms vorantreibt — leistungsstark, wettbewerbsfähig und auf die Anforderungen eines sich wandelnden Marktes ausgerichtet.",
        mp1: "Eigenes Schmieden, Bearbeiten & Härten",
        mp2: "100% Qualitätsprüfung vor Versand",
        mp3: "OEM-Materialien, rückverfolgbar",
        mp4: "Werksdirekte Preise — keine Zwischenhändler",
        whKicker: "Globales Lager",
        whT1: "Globaler Bestand.",
        whT2: "Sofortige Verfügbarkeit.",
        whSub:
          "Unsere Läger führen Tausende Rollen, Leiträder, Ketten und Bodenplatten in ständigem Bestand — vorbereitet für den weltweiten Versand, sobald ein Auftrag bestätigt ist.",
        mapKicker: "Globale Präsenz",
        mapTitle: "Eine Marke. Jeder Kontinent.",
        mapDesc: "VANROCK ist über vier Regionalbüros in München, Fort Worth, Dandenong und Ludhiana aktiv — und unterstützt Händler in Europa, Nordamerika, Australien und Asien mit lokalen Ansprechpartnern, lokalen Zeitzonen und einem gemeinsamen Bestandsnetzwerk.",
        mapSub:
          "VANROCK-Teile laufen auf Maschinen auf Bau- und Bergbaustellen weltweit — über unser Händlernetz und Direktexporte.",
        ms1: "Belieferte Länder",
        ms2: "Kontinente",
        ms3: "Angebotsantwort",
        ms4: "Weltweiter Versand",
        galKicker: "Inside VANROCK",
        galTitle: "Lager",
        teamKicker: "Unsere Mitarbeiter",
        teamTitle: "Ein Team. Ein Standard.",
        teamSub: "Hinter jeder VANROCK-Komponente steht ein Team aus Ingenieuren, Produktionsspezialisten und Händlerbetreuern, das nach demselben Standard arbeitet — im Werk und im Einsatz.",
        factsTitle: "Zahlen & Fakten",
        scroll: "Scrollen →",
      },
      dealer: {
        heroT1: "Werden Sie",
        heroT2: "Händler.",
        heroSub:
          "Das komplette VANROCK-Fahrwerksprogramm — von Gleisketten und Rollen bis zu Gummiketten und Gummipads — wird über ein geschütztes Händlernetz vertrieben. Wenn Sie Fahrwerksteile in Ihrem Markt vertreiben oder damit beginnen möchten, ist dieses Programm für Sie gemacht.",
        b1t: "Direkte Herstellerpreise",
        b1x: "Kaufen Sie direkt bei VANROCK — ohne Zwischenhändler und Aufschläge, zu echten Herstellerpreisen.",
        b2t: "Gebietsschutz",
        b2x: "Wir begrenzen die Händlerzahl pro Region, damit Ihre Investition in die Marke VANROCK geschützt ist.",
        b3t: "Bevorzugte Lagerzuteilung",
        b3x: "Händler erhalten Erstzugriff auf Produktionsläufe und reservierte Bestände schnelldrehender Teile.",
        b4t: "Marketing-Unterstützung",
        b4x: "Co-branded Kataloge, Datenblätter, Fotografie und Launch-Support für Ihren Markt.",
        b5t: "Konsolidierter Versand",
        b5x: "Teile direkt bis vor Ihre Tür. VANROCK übernimmt Versand, Zoll und Abgaben — so einfach wie eine Online-Bestellung.",
        b6t: "Globales Netzwerk",
        b6x: "Werden Sie Teil eines Händlernetzes in Bau- und Bergbaumärkten, getragen von der VANROCK Group Gruppe.",
        howKicker: "So Funktioniert Es",
        howTitle: "Von der Bewerbung zur ersten Lieferung",
        st1t: "Bewerben",
        st1x: "Füllen Sie das Formular mit Ihren Firmendaten und Ihrem Zielgebiet aus.",
        st2t: "Prüfung",
        st2x: "Unser Team prüft Ihre Bewerbung und Markteignung — in der Regel innerhalb von 2 Werktagen.",
        st3t: "Vereinbarung",
        st3x: "Wir vereinbaren Gebiet, Preisstufe und Erstbestellung gemeinsam mit Ihrem Manager.",
        st4t: "Start",
        st4x: "Sie erhalten Kataloge, Marketingmaterial und Ihre erste Lieferung — und verkaufen VANROCK.",
        regKicker: "Registrierung",
        regTitle: "Händler-Registrierung",
        regSub:
          "Mit * markierte Felder sind Pflicht. Unser Team antwortet innerhalb von 2 Werktagen.",
        lCompany: "Firmenname *",
        lContact: "Ansprechpartner *",
        lEmail: "E-Mail *",
        lPhone: "Telefon *",
        lCountry: "Land *",
        lCity: "Stadt / Region",
        lWebsite: "Firmenwebsite",
        lType: "Geschäftstyp",
        lYears: "Jahre im Geschäft",
        lVolume: "Erwartetes Monatsvolumen",
        lBrands: "Bediente Maschinenmarken",
        lMessage: "Erzählen Sie uns von Ihrem Markt",
        selectCountry: "Land wählen…",
        select: "Wählen…",
        submit: "Bewerbung absenden →",
        submitting: "Wird gesendet…",
        okTitle: "Bewerbung erhalten.",
        okText:
          "Vielen Dank. Unser Team prüft Ihre Bewerbung für {{country}} und kontaktiert Sie unter {{email}} innerhalb von 2 Werktagen.",
      },
      chat: {
        teaser:
          "Hilfe beim Finden des richtigen Teils? Fragen Sie mich — ich kenne alle 48.000+ Teile.",
        status: "Online — antwortet in Sekunden",
        headerStatus: "Teile-Experte — antwortet in Sekunden",
        q1: "Teile für meine Maschine finden",
        q1h: "z.B. CAT 320, Komatsu PC200",
        q2: "Nach Preisen fragen",
        q2h: "Konditionen & Verfügbarkeit",
        q3: "Wie erhalte ich ein Angebot?",
        q3h: "Schnelle Antwort vom Vertrieb",
        hi: "Hallo, ich bin Ihr Teile-Experte.",
        hiSub:
          "Nennen Sie mir Marke und Modell Ihrer Maschine — ich finde die richtigen Teile und helfe beim Angebot.",
        placeholder: "z.B. Kette für CAT D6D…",
        nowShowing: "Aktuelle Seite:",
      },
    },
  },
  fr: {
    translation: {
      nav: {
        quote: "Devis",
        brands: "Marques",
        search: "Recherche Pièces",
        company: "Entreprise",
        searchPlaceholder: "RECHERCHE: MARQUE MODÈLE PIÈCE",
        insights: "Informations et perspectives de l'entreprise",
      },
      footer: {
        blurb:
          "<0>VANROCK Track Solutions</0> fait partie de <1>VANROCK Group</1> — un groupe mondial fabriquant des systèmes de train de roulement pour pelles, mini-pelles, bulldozers et chargeuses pour 350+ marques de machines.",
        visitGlobal: "Visitez notre site mondial — vanrockglobal.com ↗",
        tagline: "Pièces de train de roulement premium. Conçues pour durer.",
        catalog: "Catalogue",
        company: "Entreprise",
        contact: "Contact",
        allBrands: "Toutes les marques",
        partSearch: "Recherche de pièces",
        becomeDealer: "Devenir revendeur →",
        rights: "Tous droits réservés",
        admin: "Accès Admin",
      },
      home: {
        kicker: "Une société",
        kickerCompany: "",
        h1a: "Trouvez la pièce",
        h1b: "de train de roulement",
        h1c: "exacte.",
        heroSub:
          "Galets, rouleaux porteurs, segments de barbotin, chaînes, patins, boulons et écrous — couvrant {{brands}} marques et {{models}} modèles de machines.",
        searchBtn: "Rechercher",
        try: "Essayez :",
        statBrands: "Marques",
        statModels: "Modèles",
        statParts: "Pièces",
        browseKicker: "Parcourir Catalogue",
        brandIndex: "Index des marques",
        allN: "Toutes {{n}} →",
        modelsWord: "MODÈLES",
        topBrands: "Marques les plus cataloguées",
        azBrands: "Toutes les marques A–Z",
        browseAz: "Parcourir les {{n}} marques de A à Z",
        compKicker: "Composants",
        compTitle: "Chaque composant du train de roulement",
        f1t: "Spécification OEM",
        f1x: "Acier au bore et allié, surfaces d'usure trempées en profondeur, scellées et lubrifiées à vie.",
        f2t: "Livraison mondiale rapide",
        f2x: "Pièces expédiées du stock. Devis de livraison inclus dans chaque offre.",
        f3t: "Support technique gratuit",
        f3x: "Envoyez-nous votre numéro de série et nos spécialistes trouveront la pièce exacte.",
        dealerKicker: "Programme Revendeur",
        dealerT1: "Mettez",
        dealerT2: "dans vos rayons.",
        dealerSub:
          "Qualité constante, stock profond et prix fabricant direct — tout ce dont un revendeur a besoin. Rejoignez le réseau de revendeurs VANROCK sur votre territoire.",
        dp1: "+ Prix fabricant direct",
        dp2: "+ Protection de territoire",
        dp3: "+ Support marketing",
        dp4: "+ Allocation de stock prioritaire",
        dealerCta: "Devenir revendeur →",
        faqKicker: "FAQ",
        faqTitle: "Questions fréquentes",
        faq1q: "Quelles marques de machines couvrez-vous ?",
        faq1a:
          "Nous stockons des pièces pour 350+ marques dont Caterpillar, Komatsu, Kobelco, Hitachi, Volvo, JCB, Hyundai, Doosan, Case, Liebherr, Takeuchi, Yanmar, Kubota et bien d'autres.",
        faq2q: "Comment trouver des pièces pour ma machine ?",
        faq2a:
          "Sélectionnez votre marque, puis votre modèle exact dans la liste alphabétique. Chaque page modèle liste tous les composants disponibles.",
        faq3q: "Comment obtenir un prix ?",
        faq3a:
          "Ouvrez une page pièce et envoyez le formulaire de devis. Notre équipe répond sous un jour ouvré avec prix et disponibilité.",
        faq4q: "Les pièces sont-elles de qualité OEM ?",
        faq4a:
          "Toutes les pièces sont fabriquées selon les spécifications OEM en aciers au bore et alliés, avec surfaces d'usure trempées et ensembles lubrifiés à vie.",
      },
      company: {
        h1a: "Conçu pour les terrains",
        h1b: "les plus durs au monde.",
        heroSub:
          "VANROCK Track Solutions est la division train de roulement de VANROCK Group — ingénierie, forgeage et usinage de systèmes de chenilles pour les grandes marques mondiales, au service des revendeurs et des flottes.",
        visitGlobal: "Visiter notre site mondial ↗",
        s1: "Marques de machines couvertes",
        s2: "Pièces conçues & cataloguées",
        s3: "Modèles de machines pris en charge",
        s4: "Contrôle qualité avant expédition",
        madeKicker: "Made In VANROCK",
        madeT1: "Toutes les pièces fabriquées à 100% dans",
        madeT2: "l'usine VANROCK.",
        madeT3: "Aucune sous-traitance.",
        madeSub:
          "De l'acier au bore brut au composant fini, tout le processus se déroule sous un même toit — la qualité est contrôlée à chaque étape.",
        mp1: "Forgeage, usinage & traitement thermique internes",
        mp2: "Contrôle qualité 100% avant expédition",
        mp3: "Matériaux OEM, traçables à la source",
        mp4: "Prix direct usine — sans intermédiaires",
        whKicker: "Entrepôt Mondial",
        whT1: "Stock profond.",
        whT2: "Expédition rapide.",
        whSub:
          "Des milliers de galets, roues folles, chaînes et patins en rayon en permanence — prêts à partir dès confirmation de votre commande.",
        mapKicker: "Présence Mondiale",
        mapTitle: "Une marque. Tous les continents.",
        mapDesc: "VANROCK s'appuie sur quatre bureaux régionaux à Munich, Fort Worth, Dandenong et Ludhiana — au service des distributeurs d'Europe, d'Amérique du Nord, d'Australie et d'Asie, avec des contacts locaux, des fuseaux horaires locaux et un réseau de stock commun.",
        mapSub:
          "Les pièces VANROCK équipent des machines sur les chantiers de construction et sites miniers du monde entier — via notre réseau de revendeurs et l'export direct.",
        ms1: "Pays desservis",
        ms2: "Continents",
        ms3: "Réponse au devis",
        ms4: "Expédition mondiale",
        galKicker: "Inside VANROCK",
        galTitle: "Production & entrepôt",
        teamKicker: "Nos Équipes",
        teamTitle: "Une équipe. Un standard.",
        teamSub: "Derrière chaque composant VANROCK, une équipe d'ingénieurs, de spécialistes de production et de support aux distributeurs travaille selon le même standard — à l'usine comme sur le terrain.",
        factsTitle: "Chiffres clés",
        scroll: "Défiler →",
      },
      dealer: {
        heroT1: "Devenez revendeur",
        heroT2: "dès aujourd'hui.",
        heroSub:
          "Les chaînes, patins, galets, roues folles et barbotins VANROCK sont vendus via un réseau de revendeurs protégé. Si vous distribuez des pièces de train de roulement, ce programme est fait pour vous.",
        b1t: "Prix fabricant direct",
        b1x: "Achetez directement auprès de VANROCK — sans intermédiaires ni marges, aux vrais tarifs fabricant.",
        b2t: "Protection de territoire",
        b2x: "Nous limitons le nombre de revendeurs par région pour protéger votre investissement dans la marque VANROCK.",
        b3t: "Stock prioritaire",
        b3x: "Les revendeurs ont un accès prioritaire aux productions et aux stocks réservés des pièces à forte rotation.",
        b4t: "Support marketing",
        b4x: "Catalogues co-brandés, fiches produits, photographie et accompagnement au lancement sur votre marché.",
        b5t: "Expédition consolidée",
        b5x: "Consolidation en conteneur complet ou mixte depuis notre entrepôt, documentation export incluse.",
        b6t: "Réseau mondial",
        b6x: "Rejoignez des revendeurs des marchés de la construction et des mines, soutenus par le groupe VANROCK Group.",
        howKicker: "Comment Ça Marche",
        howTitle: "De la candidature à la première expédition",
        st1t: "Candidature",
        st1x: "Remplissez le formulaire ci-dessous avec vos coordonnées et votre territoire cible.",
        st2t: "Examen",
        st2x: "Notre équipe examine votre candidature — généralement sous 2 jours ouvrés.",
        st3t: "Accord",
        st3x: "Nous convenons du territoire, du niveau tarifaire et de la première commande avec votre manager dédié.",
        st4t: "Lancement",
        st4x: "Vous recevez catalogues, supports marketing et votre première expédition — et commencez à vendre VANROCK.",
        regKicker: "Inscription",
        regTitle: "Inscription revendeur",
        regSub:
          "Les champs marqués * sont obligatoires. Notre équipe répond sous 2 jours ouvrés.",
        lCompany: "Nom de l'entreprise *",
        lContact: "Personne de contact *",
        lEmail: "Email *",
        lPhone: "Téléphone *",
        lCountry: "Pays *",
        lCity: "Ville / région",
        lWebsite: "Site web",
        lType: "Type d'activité",
        lYears: "Années d'activité",
        lVolume: "Volume mensuel prévu",
        lBrands: "Marques de machines servies",
        lMessage: "Parlez-nous de votre marché",
        selectCountry: "Choisir un pays…",
        select: "Choisir…",
        submit: "Envoyer la candidature →",
        submitting: "Envoi…",
        okTitle: "Candidature reçue.",
        okText:
          "Merci. Notre équipe examinera votre candidature pour {{country}} et vous contactera à {{email}} sous 2 jours ouvrés.",
      },
      chat: {
        teaser:
          "Besoin d'aide pour trouver la bonne pièce ? Demandez-moi — je connais les 48 000+ pièces.",
        status: "En ligne — répond en quelques secondes",
        headerStatus: "Expert pièces — répond en secondes",
        q1: "Trouver des pièces pour ma machine",
        q1h: "ex. CAT 320, Komatsu PC200",
        q2: "Demander les prix",
        q2h: "Conditions commerciales et disponibilité",
        q3: "Comment obtenir un devis ?",
        q3h: "Réponse rapide des ventes",
        hi: "Bonjour, je suis votre expert pièces.",
        hiSub:
          "Indiquez-moi la marque et le modèle de votre machine — je trouve les bonnes pièces et vous aide à obtenir un devis.",
        placeholder: "ex. Chaîne pour CAT D6D…",
        nowShowing: "Page affichée :",
      },
    },
  },
  es: {
    translation: {
      fd: { leaving: "Está saliendo de VANROCK Track Solutions", headline: "La mayor gama de mandos finales del mundo", body: "Los mandos finales están en nuestra tienda online dedicada, VANROCK Drives — con disponibilidad inmediata, presupuestos, listas de piezas y envío mundial para miles de modelos de máquinas.", continue: "Continuar al sitio", stay: "Quedarse aquí" },
      ext: { groupHeadline: "La sede corporativa de VANROCK", groupBody: "Se dirige al sitio web corporativo de VANROCK Group — las empresas, divisiones y operaciones globales del grupo en un solo lugar." },
      nav: {
        quote: "Cotización",
        brands: "Marcas",
        search: "Buscar Piezas",
        products: "Grupos de productos",
        productsLine:
          "Cada pieza de desgaste del tren de rodaje, organizada por componente.",
        company: "Empresa",
        searchPlaceholder: "BUSCAR: MARCA MODELO PIEZA",
        insights: "Información y novedades de la empresa",
      },
      footer: {
        blurb:
          "<0>VANROCK Track Solutions</0> es la división de tren de rodaje de <1>VANROCK Group</1> — un fabricante de equipos pesados que diseña implementos de construcción de alto rendimiento: cucharas trituradoras, cucharas cribadoras, martillos hidráulicos, fresadoras de tambor y sierras para roca — presentes en obras de construcción, minería y canteras de todo el mundo.",
        visitGlobal: "Visite nuestro sitio global — vanrockglobal.com ↗",
        tagline: "Piezas de rodaje. Hechas para durar.",
        catalog: "Catálogo",
        company: "Empresa",
        contact: "Contacto",
        allBrands: "Todas las marcas",
        partSearch: "Buscar piezas",
        becomeDealer: "Hazte distribuidor →",
        rights: "Todos los derechos reservados",
        admin: "Acceso Admin",
      },
      home: {
        kicker: "Una marca de",
        kickerCompany: "",
        h1a: "Encuentra la pieza",
        h1b: "de rodaje",
        h1c: "exacta.",
        heroSub:
          "Rodillos, rodillos superiores, segmentos de rueda motriz, cadenas, zapatas, tornillos y tuercas — cubriendo {{brands}} marcas y {{models}} modelos de máquinas.",
        searchBtn: "Buscar",
        try: "Prueba:",
        statBrands: "Marcas",
        statModels: "Modelos",
        statParts: "Piezas",
        browseKicker: "Explorar Catálogo",
        brandIndex: "Índice de marcas",
        allN: "Todas {{n}} →",
        modelsWord: "MODELOS",
        topBrands: "Marcas más catalogadas",
        azBrands: "Todas las marcas A–Z",
        browseAz: "Ver las {{n}} marcas de la A a la Z",
        compKicker: "Componentes",
        compTitle: "Cada componente del tren de rodaje",
        compView: "Ver catálogo →",
        compDesc: {
          "track-roller":
            "Los rodillos inferiores se desplazan por la parte inferior del bastidor y soportan todo el peso de la máquina sobre el riel de la cadena. Disponibles de brida simple o doble, sellados y lubricados de por vida.",
          "carrier-roller":
            "Los rodillos superiores soportan el tramo superior de la cadena y la mantienen alineada entre la rueda guía y el sprocket, evitando la caída y el desgaste lateral.",
          idler:
            "La rueda guía dirige la cadena en la parte delantera del bastidor y trabaja junto al tensor para mantener la tensión correcta de la cadena.",
          sprocket:
            "El sprocket engrana con los casquillos de la cadena y transmite la fuerza de tracción a la oruga. Los sprockets se montan directamente en el mando final; los segmentos van atornillados y pueden sustituirse sin abrir la cadena.",
          "track-chain":
            "La cadena es la columna vertebral del tren de rodaje: eslabones, pasadores y casquillos que transfieren el peso de la máquina a las zapatas. Disponible en versión sellada y lubricada o seca.",
          "track-shoe":
            "Las zapatas se atornillan a los eslabones de la cadena y forman la superficie de contacto con el suelo. La altura del taco y el ancho de la zapata determinan la tracción y la presión sobre el terreno.",
          "track-group":
            "El grupo de oruga es un conjunto completo de cadena y zapatas montadas, listo para instalarse en la máquina como una sola unidad.",
          "rubber-track":
            "Las orugas de goma combinan cables de acero internos y núcleos metálicos con una banda de goma — para miniexcavadoras y máquinas compactas que trabajan sobre superficies que las orugas de acero dañarían.",
          "track-bolt-nut":
            "Los tornillos y tuercas de zapata fijan las zapatas a los eslabones. Fijaciones templadas con par de apriete definido, dimensionadas según el tipo de zapata y cadena.",
          "rubber-pad":
            "Los tacos de goma permiten que las máquinas de cadenas de acero trabajen sobre asfalto, hormigón y superficies acabadas sin dañarlas. Cada taco se vulcaniza individualmente sobre un núcleo metálico — en versión atornillada (bolt-on), sobre cadena (chain-on), de pinza (clip-on) y para carretera, según el paso de cadena.",
        },
        rp: {
          sysKicker: "SISTEMAS DE MONTAJE",
          vname: {
            "bolt-on": "Tacos de goma atornillados (bolt-on)",
            "chain-on": "Tacos de goma sobre cadena (chain-on)",
            "hd-vgrip": "Tacos de goma Heavy Duty sobre cadena",
            "clip-on": "Tacos de goma de pinza (clip-on)",
            road: "Tacos para carretera",
          },
          vdesc: {
            "bolt-on":
              "Se atornillan a las zapatas a través de orificios adicionales. VANROCK suministra zapatas pretaladradas para tacos bolt-on como solución completa.",
            "chain-on":
              "Se montan directamente sobre la cadena — la máquina rueda sobre goma sin zapatas.",
            "hd-vgrip":
              "Más resistentes al desgaste que los tacos chain-on estándar.",
            "clip-on":
              "Se fijan a presión alrededor de la zapata montada. Los perfiles de zapata varían según el fabricante — mida su zapata antes de pedir; los tacos clip-on siempre encajan en las zapatas VANROCK.",
            road: "Tacos planos para circulación por carretera: goma para más agarre, o poliuretano vertido directamente sobre la zapata — extremadamente resistente al desgaste, a aceites, gasolina y grasa.",
          },
          colCode: "Código de producto",
          colPitch: "Paso de cadena",
          colMaterial: "Material",
          mm: "Todas las medidas en mm",
          withHw: "Se suministran con tornillos y tuercas",
          quote: "Solicitar cotización →",
          dimRef: "Referencia de medidas",
          refLine:
            "{{count}} referencias de tacos en {{variants}} sistemas de montaje — solicite cotización con su código VANROCK.",
          matPoly: "Poliuretano",
          matRubber: "Goma",
        },
        f1t: "Especificación OEM",
        f1x: "Acero al boro y aleado, superficies de desgaste endurecidas, selladas y lubricadas de por vida.",
        f2t: "Envío mundial rápido",
        f2x: "Piezas despachadas desde stock. Cotización de envío incluida en cada oferta.",
        f3t: "Soporte técnico gratuito",
        f3x: "Envíenos su número de serie y nuestros especialistas encontrarán la pieza exacta.",
        dealerKicker: "Programa Distribuidores",
        dealerT1: "Pon",
        dealerT2: "en tu estantería.",
        dealerSub:
          "Calidad constante, stock profundo y precios directos de fabricante — todo lo que un distribuidor necesita. Únete a la red de distribuidores VANROCK en tu territorio.",
        dp1: "+ Precio directo de fabricante",
        dp2: "+ Protección de territorio",
        dp3: "+ Apoyo de marketing",
        dp4: "+ Asignación prioritaria de stock",
        dealerCta: "Hazte distribuidor →",
        faqKicker: "FAQ",
        faqTitle: "Preguntas frecuentes",
        faq1q: "¿Qué marcas de maquinaria cubren?",
        faq1a:
          "Tenemos piezas de rodaje para 350+ marcas, incluidas Caterpillar, Komatsu, Kobelco, Hitachi, Volvo, JCB, Hyundai, Doosan, Case, Liebherr, Takeuchi, Yanmar, Kubota y muchas más.",
        faq2q: "¿Cómo encuentro piezas para mi máquina?",
        faq2a:
          "Seleccione su marca y luego su modelo exacto en la lista alfabética. Cada página de modelo lista todos los componentes disponibles.",
        faq3q: "¿Cómo obtengo precios?",
        faq3a:
          "Abra cualquier página de pieza y envíe el formulario de cotización. Nuestro equipo responde con precio y disponibilidad.",
        faq4q: "¿Las piezas son de calidad OEM?",
        faq4a:
          "Todas las piezas se fabrican según especificaciones OEM en aceros al boro y aleados, con superficies endurecidas y conjuntos lubricados de por vida.",
      },
      company: {
        h1a: "Hecho para los terrenos",
        h1b: "más duros del mundo.",
        heroSub:
          "VANROCK Track Solutions es la división de tren de rodaje de VANROCK Group — ingeniería, forja y mecanizado de sistemas de orugas para las principales marcas del mundo, sirviendo a distribuidores y flotas.",
        visitGlobal: "Visitar nuestro sitio global ↗",
        s1: "Marcas de maquinaria cubiertas",
        s2: "Piezas diseñadas y catalogadas",
        s3: "Modelos de máquinas soportados",
        s4: "Calidad inspeccionada antes del envío",
        madeKicker: "Made In VANROCK",
        madeT1: "Diseñado, forjado y",
        madeT2: "acabado en nuestra planta.",
        madeT3: "Control de principio a fin.",
        madeSub:
          "Nuestra fabricación está integrada verticalmente en todo el ciclo de producción — forja, fundición y estampación, mecanizado de precisión, tratamientos térmicos y montaje de cadenas. La inversión sostenida en la automatización de procesos nos da supervisión directa de la calidad y la continuidad del suministro en cada etapa, mientras un programa propio de investigación y desarrollo impulsa la ampliación continua de nuestra gama — diseñada para rendir, competitiva en precio y alineada con las exigencias de un mercado en evolución.",
        mp1: "Forja, mecanizado y tratamiento térmico propios",
        mp2: "Inspección de calidad 100% antes del envío",
        mp3: "Materiales OEM, trazables al origen",
        mp4: "Precio directo de fábrica — sin intermediarios",
        whKicker: "Almacén Global",
        whT1: "Inventario global.",
        whT2: "Disponibilidad inmediata.",
        whSub:
          "Nuestros almacenes mantienen miles de rodillos, ruedas guía, cadenas y zapatas en stock permanente, preparados para su expedición mundial en cuanto se confirma el pedido.",
        mapKicker: "Presencia Global",
        mapTitle: "Una marca. Todos los continentes.",
        mapDesc: "VANROCK opera a través de cuatro oficinas regionales en Múnich, Fort Worth, Dandenong y Ludhiana — apoyando a distribuidores de Europa, Norteamérica, Australia y Asia con contactos locales, husos horarios locales y una red de inventario compartida.",
        mapSub:
          "Las piezas VANROCK trabajan en máquinas de obras y minas de todo el mundo — a través de nuestra red de distribuidores y exportación directa.",
        ms1: "Países atendidos",
        ms2: "Continentes",
        ms3: "Respuesta de cotización",
        ms4: "Envío mundial",
        galKicker: "Inside VANROCK",
        galTitle: "Almacén",
        teamKicker: "Nuestra Gente",
        teamTitle: "Un equipo. Un estándar.",
        teamSub: "Detrás de cada componente VANROCK hay un equipo de ingenieros, especialistas de producción y personal de soporte a distribuidores que trabaja bajo el mismo estándar — en la planta y en el terreno.",
        factsTitle: "Cifras y datos",
        scroll: "Desplazar →",
      },
      dealer: {
        heroT1: "Hazte distribuidor",
        heroT2: "hoy.",
        heroSub:
          "La gama completa de rodaje VANROCK — desde cadenas y rodillos hasta orugas de goma y tacos — se vende a través de una red de distribuidores protegida. Si distribuye piezas de rodaje en su mercado, o quiere empezar a hacerlo, este programa es para usted.",
        b1t: "Precio directo de fabricante",
        b1x: "Compre directamente a VANROCK — sin intermediarios ni márgenes, a verdaderas tarifas de fabricante.",
        b2t: "Protección de territorio",
        b2x: "Limitamos el número de distribuidores por región para proteger su inversión en la marca VANROCK.",
        b3t: "Stock prioritario",
        b3x: "Los distribuidores tienen acceso prioritario a producciones y stock reservado de piezas de alta rotación.",
        b4t: "Apoyo de marketing",
        b4x: "Catálogos co-brandeados, fichas técnicas, fotografía y apoyo de lanzamiento para su mercado local.",
        b5t: "Envío consolidado",
        b5x: "Piezas entregadas directamente en su puerta. VANROCK se encarga del envío, las aduanas y los aranceles — tan fácil como comprar en línea.",
        b6t: "Red global",
        b6x: "Únase a distribuidores de los mercados de construcción y minería, respaldados por el grupo VANROCK Group.",
        howKicker: "Cómo Funciona",
        howTitle: "De la solicitud al primer envío",
        st1t: "Solicitar",
        st1x: "Complete el formulario con los datos de su empresa y territorio objetivo.",
        st2t: "Revisión",
        st2x: "Nuestro equipo revisa su solicitud — normalmente en 2 días hábiles.",
        st3t: "Acuerdo",
        st3x: "Acordamos territorio, nivel de precios y primer pedido junto con su gerente dedicado.",
        st4t: "Lanzamiento",
        st4x: "Recibe catálogos, material de marketing y su primer envío — y empieza a vender VANROCK.",
        regKicker: "Registro",
        regTitle: "Registro de distribuidor",
        regSub:
          "Los campos marcados * son obligatorios. Nuestro equipo responde en 2 días hábiles.",
        lCompany: "Nombre de la empresa *",
        lContact: "Persona de contacto *",
        lEmail: "Email *",
        lPhone: "Teléfono *",
        lCountry: "País *",
        lCity: "Ciudad / región",
        lWebsite: "Sitio web",
        lType: "Tipo de negocio",
        lYears: "Años en el negocio",
        lVolume: "Volumen mensual esperado",
        lBrands: "Marcas de máquinas que atiende",
        lMessage: "Cuéntenos sobre su mercado",
        selectCountry: "Seleccionar país…",
        select: "Seleccionar…",
        submit: "Enviar solicitud →",
        submitting: "Enviando…",
        okTitle: "Solicitud recibida.",
        okText:
          "Gracias. Nuestro equipo revisará su solicitud para {{country}} y le contactará en {{email}} en 2 días hábiles.",
      },
      chat: {
        teaser:
          "¿Necesita ayuda para encontrar la pieza correcta? Pregúnteme — conozco las 48.000+ piezas.",
        status: "En línea — responde en segundos",
        headerStatus: "Experto en piezas — responde en segundos",
        q1: "Buscar piezas para mi máquina",
        q1h: "ej. CAT 320, Komatsu PC200",
        q2: "Preguntar por precios",
        q2h: "Condiciones comerciales y disponibilidad",
        q3: "¿Cómo obtengo una cotización?",
        q3h: "Respuesta rápida de ventas",
        hi: "Hola, soy su experto en piezas.",
        hiSub:
          "Dígame la marca y el modelo de su máquina — encontraré las piezas correctas y le ayudaré con la cotización.",
        placeholder: "ej. Cadena para CAT D6D…",
        nowShowing: "Mostrando:",
      },
    },
  },
  ro: {
    translation: {
      nav: {
        quote: "Ofertă",
        brands: "Mărci",
        search: "Căutare Piese",
        company: "Companie",
        searchPlaceholder: "CAUTĂ: MARCĂ MODEL PIESĂ",
        insights: "Informații și perspective despre companie",
      },
      footer: {
        blurb:
          "<0>VANROCK Track Solutions</0> face parte din <1>VANROCK Group</1> — un grup mondial care produce sisteme de rulare pentru excavatoare, miniexcavatoare, buldozere și încărcătoare, pentru 350+ mărci de utilaje.",
        visitGlobal: "Vizitați site-ul nostru global — vanrockglobal.com ↗",
        tagline: "Piese de rulare premium. Construite să dureze.",
        catalog: "Catalog",
        company: "Companie",
        contact: "Contact",
        allBrands: "Toate mărcile",
        partSearch: "Căutare piese",
        becomeDealer: "Devino dealer →",
        rights: "Toate drepturile rezervate",
        admin: "Acces Admin",
      },
      home: {
        kicker: "O companie",
        kickerCompany: "",
        h1a: "Găsește piesa de rulare",
        h1b: "exactă pentru",
        h1c: "utilajul tău.",
        heroSub:
          "Role de rulare, role superioare, segmente de pinion, lanțuri, plăci, șuruburi și piulițe — acoperind {{brands}} mărci și {{models}} modele de utilaje.",
        searchBtn: "Caută",
        try: "Încearcă:",
        statBrands: "Mărci",
        statModels: "Modele",
        statParts: "Piese",
        browseKicker: "Răsfoiește Catalogul",
        brandIndex: "Index mărci",
        allN: "Toate {{n}} →",
        modelsWord: "MODELE",
        topBrands: "Cele mai catalogate mărci",
        azBrands: "Toate mărcile A–Z",
        compKicker: "Componente",
        compTitle: "Fiecare componentă a trenului de rulare",
        f1t: "Specificație OEM",
        f1x: "Oțel cu bor și aliat, suprafețe de uzură călite în profunzime, etanșate și lubrifiate pe viață.",
        f2t: "Livrare rapidă în toată lumea",
        f2x: "Piese expediate din stoc. Ofertă de livrare inclusă la fiecare cotație.",
        f3t: "Suport tehnic gratuit",
        f3x: "Trimiteți-ne seria utilajului și specialiștii noștri identifică piesa exactă.",
        dealerKicker: "Program Dealeri",
        dealerT1: "Pune",
        dealerT2: "pe raftul tău.",
        dealerSub:
          "Calitate constantă, stoc bogat și prețuri directe de producător — tot ce are nevoie un dealer. Alătură-te rețelei de dealeri VANROCK în teritoriul tău.",
        dp1: "+ Preț direct de producător",
        dp2: "+ Protecție teritorială",
        dp3: "+ Suport de marketing",
        dp4: "+ Alocare prioritară de stoc",
        dealerCta: "Devino dealer →",
        faqKicker: "FAQ",
        faqTitle: "Întrebări frecvente",
        faq1q: "Ce mărci de utilaje acoperiți?",
        faq1a:
          "Avem piese de rulare pentru 350+ mărci, inclusiv Caterpillar, Komatsu, Kobelco, Hitachi, Volvo, JCB, Hyundai, Doosan, Case, Liebherr, Takeuchi, Yanmar, Kubota și multe altele.",
        faq2q: "Cum găsesc piese pentru utilajul meu?",
        faq2a:
          "Selectați marca, apoi modelul exact din lista alfabetică. Fiecare pagină de model listează toate componentele de rulare disponibile.",
        faq3q: "Cum aflu prețurile?",
        faq3a:
          "Deschideți orice pagină de piesă și trimiteți formularul de cotație. Echipa noastră răspunde într-o zi lucrătoare cu preț și disponibilitate.",
        faq4q: "Piesele sunt de calitate OEM?",
        faq4a:
          "Toate piesele sunt fabricate conform specificațiilor OEM din oțeluri cu bor și aliate, cu suprafețe de uzură călite și ansambluri lubrifiate pe viață.",
      },
      company: {
        h1a: "Construit pentru cele mai dure",
        h1b: "terenuri din lume.",
        heroSub:
          "VANROCK Track Solutions este divizia de tren de rulare a VANROCK Group — proiectăm, forjăm și prelucrăm sisteme de șenile pentru cele mai importante mărci de utilaje, deservind dealeri și flote din întreaga lume.",
        visitGlobal: "Vizitați site-ul global ↗",
        s1: "Mărci de utilaje acoperite",
        s2: "Piese proiectate și catalogate",
        s3: "Modele de utilaje suportate",
        s4: "Calitate verificată înainte de livrare",
        madeKicker: "Made In VANROCK",
        madeT1: "Toate piesele fabricate 100% în",
        madeT2: "fabrica proprie VANROCK.",
        madeT3: "Fără externalizare.",
        madeSub:
          "De la oțelul brut cu bor la componenta finită, întregul proces are loc sub același acoperiș — calitatea este controlată la fiecare pas.",
        mp1: "Forjare, prelucrare și tratament termic propriu",
        mp2: "Inspecție de calitate 100% înainte de livrare",
        mp3: "Materiale OEM, trasabile la sursă",
        mp4: "Preț direct din fabrică — fără intermediari",
        whKicker: "Depozit Global",
        whT1: "Stoc bogat.",
        whT2: "Livrare rapidă.",
        whSub:
          "Mii de role, roți de ghidare, lanțuri și plăci pe raft în permanență — gata de expediere imediat ce comanda este confirmată.",
        mapKicker: "Prezență Globală",
        mapTitle: "Un brand. Toate continentele.",
        mapDesc: "VANROCK operează prin patru birouri regionale în München, Fort Worth, Dandenong și Ludhiana — sprijinind dealerii din Europa, America de Nord, Australia și Asia cu contacte locale, fusuri orare locale și o rețea comună de stocuri.",
        mapSub:
          "Piesele VANROCK lucrează pe utilaje de pe șantiere de construcții și situri miniere din întreaga lume — prin rețeaua noastră de dealeri și export direct.",
        ms1: "Țări deservite",
        ms2: "Continente",
        ms3: "Răspuns la cotație",
        ms4: "Livrare mondială",
        galKicker: "Inside VANROCK",
        galTitle: "Producție și depozit",
        teamKicker: "Oamenii Noștri",
        teamTitle: "O echipă. Un standard.",
        teamSub: "În spatele fiecărei componente VANROCK se află o echipă de ingineri, specialiști în producție și personal de suport pentru dealeri, care lucrează la același standard — în fabrică și pe teren.",
        factsTitle: "Cifre și date",
        scroll: "Derulează →",
      },
      dealer: {
        heroT1: "Devino dealer",
        heroT2: "astăzi.",
        heroSub:
          "Lanțurile, plăcile, rolele, roțile de ghidare și pinioanele VANROCK sunt vândute printr-o rețea protejată de dealeri. Dacă distribuiți piese de rulare pe piața dvs., acest program este creat pentru dvs.",
        b1t: "Preț direct de producător",
        b1x: "Cumpărați direct de la VANROCK — fără intermediari și adaosuri, la tarife reale de producător.",
        b2t: "Protecție teritorială",
        b2x: "Limităm numărul de dealeri pe regiune pentru a vă proteja investiția în brandul VANROCK.",
        b3t: "Stoc prioritar",
        b3x: "Dealerii au acces prioritar la producție și stoc rezervat pentru piesele cu rotație rapidă.",
        b4t: "Suport de marketing",
        b4x: "Cataloage co-branded, fișe tehnice, fotografie și suport de lansare pentru piața dvs. locală.",
        b5t: "Transport consolidat",
        b5x: "Consolidare container complet sau mixt din depozitul nostru, cu documentația de export inclusă.",
        b6t: "Rețea globală",
        b6x: "Alăturați-vă dealerilor din piețele de construcții și minerit, susținuți de grupul VANROCK Group.",
        howKicker: "Cum Funcționează",
        howTitle: "De la aplicare la prima livrare",
        st1t: "Aplică",
        st1x: "Completați formularul de mai jos cu datele companiei și teritoriul vizat.",
        st2t: "Evaluare",
        st2x: "Echipa noastră evaluează aplicația — de regulă în 2 zile lucrătoare.",
        st3t: "Acord",
        st3x: "Stabilim împreună teritoriul, nivelul de preț și prima comandă, alături de managerul dedicat.",
        st4t: "Lansare",
        st4x: "Primiți cataloage, materiale de marketing și prima livrare — și începeți să vindeți VANROCK.",
        regKicker: "Înregistrare",
        regTitle: "Înregistrare dealer",
        regSub:
          "Câmpurile marcate cu * sunt obligatorii. Echipa noastră răspunde în 2 zile lucrătoare.",
        lCompany: "Numele companiei *",
        lContact: "Persoană de contact *",
        lEmail: "Email *",
        lPhone: "Telefon *",
        lCountry: "Țara *",
        lCity: "Oraș / regiune",
        lWebsite: "Site-ul companiei",
        lType: "Tip de afacere",
        lYears: "Ani de activitate",
        lVolume: "Volum lunar estimat",
        lBrands: "Mărci de utilaje deservite",
        lMessage: "Spuneți-ne despre piața dvs.",
        selectCountry: "Selectați țara…",
        select: "Selectați…",
        submit: "Trimite aplicația →",
        submitting: "Se trimite…",
        okTitle: "Aplicație primită.",
        okText:
          "Mulțumim. Echipa noastră va analiza aplicația pentru {{country}} și vă va contacta la {{email}} în 2 zile lucrătoare.",
      },
      chat: {
        teaser:
          "Aveți nevoie de ajutor să găsiți piesa potrivită? Întrebați-mă — cunosc toate cele 48.000+ piese.",
        status: "Online — răspunde în secunde",
        headerStatus: "Expert piese — răspunde în secunde",
        q1: "Găsește piese pentru utilajul meu",
        q1h: "ex. CAT 320, Komatsu PC200",
        q2: "Întreabă despre prețuri",
        q2h: "Condiții comerciale și disponibilitate",
        q3: "Cum obțin o cotație?",
        q3h: "Răspuns rapid de la vânzări",
        hi: "Salut, sunt expertul tău în piese.",
        hiSub:
          "Spune-mi marca și modelul utilajului — găsesc piesele potrivite și te ajut cu o cotație.",
        placeholder: "ex. Lanț pentru CAT D6D…",
        nowShowing: "Pagina curentă:",
      },
    },
  },
  it: {
    translation: {
      fd: { leaving: "Stai lasciando VANROCK Track Solutions", headline: "La più ampia gamma di riduttori di traslazione al mondo", body: "I riduttori di traslazione sono disponibili nel nostro store online dedicato, VANROCK Drives — con disponibilità immediata, preventivi, liste ricambi e spedizioni in tutto il mondo per migliaia di modelli di macchine.", continue: "Continua al sito", stay: "Rimani qui" },
      ext: { groupHeadline: "La sede corporate di VANROCK", groupBody: "Stai per visitare il sito corporate di VANROCK Group — le aziende, le divisioni e le attività globali del gruppo in un unico posto." },
      nav: {
        quote: "Preventivo",
        brands: "Marchi",
        search: "Ricerca Ricambi",
        products: "Gruppi di prodotti",
        productsLine:
          "Ogni ricambio di usura del sottocarro, organizzato per componente.",
        company: "Azienda",
        searchPlaceholder: "CERCA: MARCA MODELLO RICAMBIO",
        insights: "Informazioni e approfondimenti aziendali",
      },
      footer: {
        blurb:
          "<0>VANROCK Track Solutions</0> è la divisione sottocarro di <1>VANROCK Group</1> — un costruttore di macchinari pesanti che progetta attrezzature per l'edilizia ad alte prestazioni: benne frantumatrici, benne vagliatrici, martelli demolitori, fresatrici a tamburo e seghe da roccia — scelte in cantieri edili, minerari e di cava in tutto il mondo.",
        visitGlobal: "Visita il nostro sito globale — vanrockglobal.com ↗",
        tagline: "Ricambi sottocarro. Fatti per durare.",
        catalog: "Catalogo",
        company: "Azienda",
        contact: "Contatti",
        allBrands: "Tutti i marchi",
        partSearch: "Ricerca ricambi",
        becomeDealer: "Diventa rivenditore →",
        rights: "Tutti i diritti riservati",
        admin: "Accesso Admin",
      },
      home: {
        kicker: "Un marchio",
        kickerCompany: "",
        h1a: "Trova il ricambio",
        h1b: "sottocarro",
        h1c: "esatto.",
        heroSub:
          "Rulli inferiori, rulli superiori, segmenti ruota motrice, catene, suole, bulloni e dadi — per {{brands}} marchi e {{models}} modelli di macchine.",
        searchBtn: "Cerca",
        try: "Prova:",
        statBrands: "Marchi",
        statModels: "Modelli",
        statParts: "Ricambi",
        browseKicker: "Sfoglia Catalogo",
        brandIndex: "Indice marchi",
        allN: "Tutti {{n}} →",
        modelsWord: "MODELLI",
        topBrands: "Marchi più catalogati",
        azBrands: "Tutti i marchi A–Z",
        browseAz: "Sfoglia tutti i {{n}} marchi dalla A alla Z",
        compKicker: "Componenti",
        compTitle: "Ogni componente del sottocarro",
        compView: "Vedi catalogo →",
        compDesc: {
          "track-roller":
            "I rulli inferiori scorrono lungo la parte inferiore del telaio e sostengono l'intero peso della macchina sulla rotaia della catena. Disponibili a flangia singola o doppia, sigillati e lubrificati a vita.",
          "carrier-roller":
            "I rulli superiori sostengono il tratto superiore della catena e la mantengono allineata tra la ruota tendicingolo e la ruota motrice, evitando cedimenti e usura laterale.",
          idler:
            "La ruota tendicingolo guida la catena nella parte anteriore del telaio e lavora con il tenditore per mantenere la corretta tensione della catena.",
          sprocket:
            "La ruota motrice ingrana con le boccole della catena e trasmette la forza di trazione al cingolo. Le ruote motrici si montano direttamente sul riduttore finale; i segmenti sono imbullonati e sostituibili senza aprire la catena.",
          "track-chain":
            "La catena è la spina dorsale del sottocarro: maglie, perni e boccole che trasferiscono il peso della macchina alle suole. Disponibile in versione sigillata e lubrificata o a secco.",
          "track-shoe":
            "Le suole si imbullonano alle maglie della catena e formano la superficie di contatto con il terreno. L'altezza del rampone e la larghezza della suola determinano trazione e pressione al suolo.",
          "track-group":
            "Il gruppo cingolo è un insieme completo di catena e suole montate, pronto per essere installato sulla macchina come unità unica.",
          "rubber-track":
            "I cingoli in gomma combinano cavi d'acciaio interni e anime metalliche con un battistrada in gomma — per miniescavatori e macchine compatte che lavorano su superfici che i cingoli in acciaio danneggerebbero.",
          "track-bolt-nut":
            "Bulloni e dadi cingolo fissano le suole alle maglie della catena. Elementi di fissaggio temprati con coppia di serraggio definita, dimensionati per tipo di suola e catena.",
          "rubber-pad":
            "I pattini in gomma permettono alle macchine con cingoli in acciaio di lavorare su asfalto, cemento e superfici finite senza danneggiarle. Ogni pad è vulcanizzato singolarmente su un'anima metallica — nelle versioni bolt-on, chain-on, clip-on e stradale, dimensionate in base al passo catena.",
        },
        rp: {
          sysKicker: "SISTEMI DI MONTAGGIO",
          vname: {
            "bolt-on": "Pattini in gomma bolt-on (avvitati)",
            "chain-on": "Pattini in gomma chain-on (su catena)",
            "hd-vgrip": "Pattini in gomma Heavy Duty chain-on",
            "clip-on": "Pattini in gomma clip-on (a morsetto)",
            road: "Pad stradali",
          },
          vdesc: {
            "bolt-on":
              "Si avvitano alle suole tramite fori aggiuntivi. VANROCK fornisce suole preforate per i pad bolt-on come soluzione completa.",
            "chain-on":
              "Si montano direttamente sulla catena — la macchina lavora su gomma senza suole.",
            "hd-vgrip":
              "Più resistenti all'usura dei pad chain-on standard.",
            "clip-on":
              "Si fissano a morsetto attorno alla suola montata. I profili delle suole variano tra i produttori — misurare la suola prima dell'ordine; i pad clip-on si adattano sempre alle suole VANROCK.",
            road: "Pad piatti per i trasferimenti su strada: gomma per più aderenza, o poliuretano colato direttamente sulla suola — estremamente resistente all'usura, a oli, benzina e grassi.",
          },
          colCode: "Codice prodotto",
          colPitch: "Passo catena",
          colMaterial: "Materiale",
          mm: "Tutte le misure in mm",
          withHw: "Forniti con bulloni e dadi",
          quote: "Richiedi preventivo →",
          dimRef: "Riferimento dimensioni",
          refLine:
            "{{count}} referenze di pad in {{variants}} sistemi di montaggio — richiedi un preventivo con il tuo codice VANROCK.",
          matPoly: "Poliuretano",
          matRubber: "Gomma",
        },
        f1t: "Specifiche OEM",
        f1x: "Acciaio al boro e legato, superfici di usura temprate in profondità, sigillate e lubrificate a vita.",
        f2t: "Consegna rapida in tutto il mondo",
        f2x: "Ricambi spediti da magazzino. Preventivo di consegna incluso in ogni offerta.",
        f3t: "Supporto tecnico gratuito",
        f3x: "Inviaci il numero di serie e i nostri specialisti troveranno il ricambio esatto.",
        dealerKicker: "Programma Rivenditori",
        dealerT1: "Metti",
        dealerT2: "sul tuo scaffale.",
        dealerSub:
          "Qualità costante, magazzino profondo e prezzi diretti dal produttore — tutto ciò che serve a un rivenditore. Unisciti alla rete VANROCK nel tuo territorio.",
        dp1: "+ Prezzo diretto dal produttore",
        dp2: "+ Protezione territoriale",
        dp3: "+ Supporto marketing",
        dp4: "+ Stock prioritario",
        dealerCta: "Diventa rivenditore →",
        faqKicker: "FAQ",
        faqTitle: "Domande frequenti",
        faq1q: "Quali marchi di macchine coprite?",
        faq1a:
          "Abbiamo ricambi sottocarro per oltre 270 marchi tra cui Caterpillar, Komatsu, Kobelco, Hitachi, Volvo, JCB, Hyundai, Doosan, Case, Liebherr, Takeuchi, Yanmar, Kubota e molti altri.",
        faq2q: "Come trovo i ricambi per la mia macchina?",
        faq2a:
          "Seleziona il marchio, poi il modello esatto dall'elenco alfabetico. Ogni pagina modello elenca tutti i componenti sottocarro disponibili.",
        faq3q: "Come ottengo i prezzi?",
        faq3a:
          "Apri una pagina ricambio e invia il modulo di preventivo. Il nostro team risponde con prezzo e disponibilità.",
        faq4q: "I ricambi sono di qualità OEM?",
        faq4a:
          "Tutti i ricambi sono prodotti secondo specifiche OEM in acciai al boro e legati, con superfici temprate e gruppi lubrificati a vita.",
      },
      company: {
        h1a: "Costruito per i terreni",
        h1b: "più duri del mondo.",
        heroSub:
          "VANROCK Track Solutions è la divisione sottocarro di VANROCK Group — progettiamo, forgiamo e lavoriamo sistemi cingolati per i principali marchi mondiali, servendo rivenditori e flotte in tutto il mondo.",
        visitGlobal: "Visita il sito globale ↗",
        s1: "Marchi di macchine coperti",
        s2: "Ricambi progettati e catalogati",
        s3: "Modelli di macchine supportati",
        s4: "Qualità ispezionata prima della spedizione",
        madeKicker: "Made In VANROCK",
        madeT1: "Progettato, forgiato e",
        madeT2: "finito internamente.",
        madeT3: "Controllo dall'inizio alla fine.",
        madeSub:
          "La nostra produzione è integrata verticalmente lungo l'intero ciclo produttivo — forgiatura, fusione e stampaggio, lavorazione meccanica di precisione, trattamenti termici e assemblaggio delle catene. Investimenti costanti nell'automazione dei processi ci garantiscono una supervisione diretta della qualità e della continuità delle forniture in ogni fase, mentre un programma interno di ricerca e sviluppo guida l'ampliamento continuo della gamma — progettata per durare, competitiva nel prezzo e in linea con le esigenze di un mercato in evoluzione.",
        mp1: "Forgiatura, lavorazione e trattamento termico interni",
        mp2: "Ispezione qualità 100% prima della spedizione",
        mp3: "Materiali OEM, tracciabili all'origine",
        mp4: "Prezzi diretti dalla fabbrica — senza intermediari",
        whKicker: "Magazzino Globale",
        whT1: "Inventario globale.",
        whT2: "Disponibilità immediata.",
        whSub:
          "I nostri magazzini mantengono migliaia di rulli, ruote tendicingolo, catene e suole in stock permanente, pronti per la spedizione in tutto il mondo non appena l'ordine viene confermato.",
        mapKicker: "Presenza Globale",
        mapTitle: "Un marchio. Ogni continente.",
        mapDesc: "VANROCK opera attraverso quattro sedi regionali a Monaco di Baviera, Fort Worth, Dandenong e Ludhiana — al servizio dei rivenditori di Europa, Nord America, Australia e Asia con referenti locali, fusi orari locali e una rete di stock condivisa.",
        mapSub:
          "I ricambi VANROCK lavorano su macchine in cantieri e miniere di tutto il mondo — tramite la nostra rete di rivenditori ed export diretto.",
        ms1: "Paesi serviti",
        ms2: "Continenti",
        ms3: "Risposta al preventivo",
        ms4: "Spedizione mondiale",
        galKicker: "Inside VANROCK",
        galTitle: "Magazzino",
        teamKicker: "Le Nostre Persone",
        teamTitle: "Una squadra. Uno standard.",
        teamSub: "Dietro ogni componente VANROCK c'è un team di ingegneri, specialisti di produzione e personale di supporto ai rivenditori che lavora secondo lo stesso standard — in stabilimento e sul campo.",
        factsTitle: "Numeri e fatti",
        scroll: "Scorri →",
      },
      dealer: {
        heroT1: "Diventa rivenditore",
        heroT2: "oggi.",
        heroSub:
          "Catene, suole, rulli, ruote tendicingolo e ruote motrici VANROCK sono venduti tramite una rete di rivenditori protetta. Se distribuisci ricambi sottocarro nel tuo mercato, questo programma è per te.",
        b1t: "Prezzo diretto dal produttore",
        b1x: "Acquista direttamente da VANROCK — senza intermediari né ricarichi, a vere tariffe da produttore.",
        b2t: "Protezione territoriale",
        b2x: "Limitiamo il numero di rivenditori per regione per proteggere il tuo investimento nel marchio VANROCK.",
        b3t: "Stock prioritario",
        b3x: "I rivenditori hanno accesso prioritario alle produzioni e allo stock riservato dei ricambi più richiesti.",
        b4t: "Supporto marketing",
        b4x: "Cataloghi co-branded, schede tecniche, fotografia e supporto al lancio per il tuo mercato locale.",
        b5t: "Spedizione consolidata",
        b5x: "Ricambi consegnati direttamente alla tua porta. VANROCK gestisce spedizione, dogana e dazi — semplice come ordinare online.",
        b6t: "Rete globale",
        b6x: "Unisciti ai rivenditori dei mercati costruzioni e mining, supportati dal gruppo VANROCK Group.",
        howKicker: "Come Funziona",
        howTitle: "Dalla candidatura alla prima spedizione",
        st1t: "Candidati",
        st1x: "Compila il modulo con i dati aziendali e il territorio di interesse.",
        st2t: "Valutazione",
        st2x: "Il nostro team valuta la candidatura — di solito entro 2 giorni lavorativi.",
        st3t: "Accordo",
        st3x: "Concordiamo territorio, fascia di prezzo e primo ordine insieme al tuo manager dedicato.",
        st4t: "Lancio",
        st4x: "Ricevi cataloghi, materiali marketing e la prima spedizione — e inizi a vendere VANROCK.",
        regKicker: "Registrazione",
        regTitle: "Registrazione rivenditore",
        regSub:
          "I campi con * sono obbligatori. Il nostro team risponde entro 2 giorni lavorativi.",
        lCompany: "Ragione sociale *",
        lContact: "Referente *",
        lEmail: "Email *",
        lPhone: "Telefono *",
        lCountry: "Paese *",
        lCity: "Città / regione",
        lWebsite: "Sito web",
        lType: "Tipo di attività",
        lYears: "Anni di attività",
        lVolume: "Volume mensile previsto",
        lBrands: "Marchi di macchine serviti",
        lMessage: "Parlaci del tuo mercato",
        selectCountry: "Seleziona paese…",
        select: "Seleziona…",
        submit: "Invia candidatura →",
        submitting: "Invio…",
        okTitle: "Candidatura ricevuta.",
        okText:
          "Grazie. Il nostro team valuterà la candidatura per {{country}} e ti contatterà a {{email}} entro 2 giorni lavorativi.",
      },
      chat: {
        teaser:
          "Serve aiuto per trovare il ricambio giusto? Chiedimi — conosco tutti i 48.000+ ricambi.",
        status: "Online — risponde in pochi secondi",
        headerStatus: "Esperto ricambi — risponde in secondi",
        q1: "Trova ricambi per la mia macchina",
        q1h: "es. CAT 320, Komatsu PC200",
        q2: "Chiedi i prezzi",
        q2h: "Condizioni commerciali e disponibilità",
        q3: "Come ottengo un preventivo?",
        q3h: "Risposta rapida dalle vendite",
        hi: "Ciao, sono il tuo esperto ricambi.",
        hiSub:
          "Dimmi marca e modello della macchina — trovo i ricambi giusti e ti aiuto con il preventivo.",
        placeholder: "es. Catena per CAT D6D…",
        nowShowing: "Pagina corrente:",
      },
    },
  },
  pt: {
    translation: {
      fd: { leaving: "Você está saindo da VANROCK Track Solutions", headline: "A maior gama de comandos finais do mundo", body: "Comandos finais estão na nossa loja online dedicada, VANROCK Drives — com disponibilidade imediata, cotações, listas de peças e envio mundial para milhares de modelos de máquinas.", continue: "Continuar para o site", stay: "Ficar aqui" },
      ext: { groupHeadline: "A casa corporativa da VANROCK", groupBody: "Você está indo para o site corporativo do VANROCK Group — as empresas, divisões e operações globais do grupo em um só lugar." },
      nav: {
        quote: "Cotação",
        brands: "Marcas",
        search: "Busca Peças",
        products: "Grupos de produtos",
        productsLine:
          "Cada peça de desgaste do material rodante, organizada por componente.",
        company: "Empresa",
        searchPlaceholder: "BUSCAR: MARCA MODELO PEÇA",
        insights: "Informações e novidades da empresa",
      },
      footer: {
        blurb:
          "<0>VANROCK Track Solutions</0> é a divisão de material rodante da <1>VANROCK Group</1> — um fabricante de equipamentos pesados que desenvolve implementos de construção de alto desempenho: caçambas trituradoras, caçambas peneiradoras, rompedores hidráulicos, fresadoras de tambor e serras para rocha — presentes em obras de construção, mineração e pedreiras em todo o mundo.",
        visitGlobal: "Visite nosso site global — vanrockglobal.com ↗",
        tagline: "Peças de material rodante. Feitas para durar.",
        catalog: "Catálogo",
        company: "Empresa",
        contact: "Contato",
        allBrands: "Todas as marcas",
        partSearch: "Busca de peças",
        becomeDealer: "Seja um revendedor →",
        rights: "Todos os direitos reservados",
        admin: "Acesso Admin",
      },
      home: {
        kicker: "Uma marca",
        kickerCompany: "",
        h1a: "Encontre a peça",
        h1b: "de material rodante",
        h1c: "exata.",
        heroSub:
          "Roletes inferiores, roletes superiores, segmentos de roda motriz, correntes, sapatas, parafusos e porcas — cobrindo {{brands}} marcas e {{models}} modelos de máquinas.",
        searchBtn: "Buscar",
        try: "Tente:",
        statBrands: "Marcas",
        statModels: "Modelos",
        statParts: "Peças",
        browseKicker: "Explorar Catálogo",
        brandIndex: "Índice de marcas",
        allN: "Todas {{n}} →",
        modelsWord: "MODELOS",
        topBrands: "Marcas mais catalogadas",
        azBrands: "Todas as marcas A–Z",
        browseAz: "Ver todas as {{n}} marcas de A a Z",
        compKicker: "Componentes",
        compTitle: "Cada componente do material rodante",
        compView: "Ver catálogo →",
        compDesc: {
          "track-roller":
            "Os roletes inferiores deslizam pela parte inferior da estrutura e suportam todo o peso da máquina sobre o trilho da corrente. Disponíveis com flange simples ou dupla, selados e lubrificados para toda a vida útil.",
          "carrier-roller":
            "Os roletes superiores apoiam o tramo superior da corrente e mantêm-na alinhada entre a roda-guia e a roda motriz, evitando folgas e desgaste lateral.",
          idler:
            "A roda-guia orienta a corrente na parte dianteira da estrutura e trabalha com o tensor para manter a tensão correta da corrente.",
          sprocket:
            "A roda motriz engrena nas buchas da corrente e transmite a força de tração à esteira. As rodas motrizes montam-se diretamente no comando final; os segmentos são aparafusados e podem ser substituídos sem abrir a corrente.",
          "track-chain":
            "A corrente é a espinha dorsal do material rodante: elos, pinos e buchas que transferem o peso da máquina para as sapatas. Disponível na versão selada e lubrificada ou seca.",
          "track-shoe":
            "As sapatas são aparafusadas aos elos da corrente e formam a superfície de contato da máquina com o solo. A altura da garra e a largura da sapata determinam a tração e a pressão sobre o solo.",
          "track-group":
            "O grupo de esteira é um conjunto completo de corrente e sapatas montadas, pronto para ser instalado na máquina como uma única unidade.",
          "rubber-track":
            "As esteiras de borracha combinam cabos de aço internos e núcleos metálicos com uma banda de borracha — para miniescavadeiras e máquinas compactas que trabalham em superfícies que as esteiras de aço danificariam.",
          "track-bolt-nut":
            "Os parafusos e porcas de sapata fixam as sapatas aos elos da corrente. Fixadores temperados com torque de aperto definido, dimensionados por tipo de sapata e corrente.",
          "rubber-pad":
            "As sapatas de borracha permitem que máquinas de esteira de aço trabalhem sobre asfalto, concreto e superfícies acabadas sem danificá-las. Cada pad é vulcanizado individualmente sobre um núcleo metálico — nas versões aparafusada (bolt-on), sobre corrente (chain-on), de encaixe (clip-on) e rodoviária, dimensionadas pelo passo da corrente.",
        },
        rp: {
          sysKicker: "SISTEMAS DE MONTAGEM",
          vname: {
            "bolt-on": "Sapatas de borracha aparafusadas (bolt-on)",
            "chain-on": "Sapatas de borracha sobre corrente (chain-on)",
            "hd-vgrip": "Sapatas de borracha Heavy Duty sobre corrente",
            "clip-on": "Sapatas de borracha de encaixe (clip-on)",
            road: "Pads rodoviários",
          },
          vdesc: {
            "bolt-on":
              "Aparafusadas às sapatas através de furos adicionais. A VANROCK fornece sapatas pré-furadas para pads bolt-on como solução completa.",
            "chain-on":
              "Montadas diretamente na corrente — a máquina roda sobre borracha sem sapatas.",
            "hd-vgrip":
              "Mais resistentes ao desgaste que os pads chain-on padrão.",
            "clip-on":
              "Fixadas por encaixe ao redor da sapata montada. Os perfis de sapata variam entre fabricantes — meça sua sapata antes de pedir; os pads clip-on sempre encaixam nas sapatas VANROCK.",
            road: "Pads planos para deslocamento em vias: borracha para mais aderência, ou poliuretano aplicado diretamente sobre a sapata — extremamente resistente ao desgaste, a óleos, gasolina e graxa.",
          },
          colCode: "Código do produto",
          colPitch: "Passo da corrente",
          colMaterial: "Material",
          mm: "Todas as medidas em mm",
          withHw: "Fornecidas com parafusos e porcas",
          quote: "Solicitar cotação →",
          dimRef: "Referência de dimensões",
          refLine:
            "{{count}} referências de pads em {{variants}} sistemas de montagem — solicite cotação com seu código VANROCK.",
          matPoly: "Poliuretano",
          matRubber: "Borracha",
        },
        f1t: "Especificação OEM",
        f1x: "Aço ao boro e ligado, superfícies de desgaste temperadas em profundidade, seladas e lubrificadas para a vida toda.",
        f2t: "Entrega rápida mundial",
        f2x: "Peças despachadas do estoque. Cotação de frete incluída em cada oferta.",
        f3t: "Suporte técnico gratuito",
        f3x: "Envie o número de série e nossos especialistas encontrarão a peça exata.",
        dealerKicker: "Programa Revendedores",
        dealerT1: "Coloque a",
        dealerT2: "na sua prateleira.",
        dealerSub:
          "Qualidade constante, estoque profundo e preços diretos de fábrica — tudo o que um revendedor precisa. Junte-se à rede de revendedores VANROCK no seu território.",
        dp1: "+ Preço direto do fabricante",
        dp2: "+ Proteção de território",
        dp3: "+ Apoio de marketing",
        dp4: "+ Alocação prioritária de estoque",
        dealerCta: "Seja um revendedor →",
        faqKicker: "FAQ",
        faqTitle: "Perguntas frequentes",
        faq1q: "Quais marcas de máquinas vocês cobrem?",
        faq1a:
          "Temos peças de material rodante para 350+ marcas, incluindo Caterpillar, Komatsu, Kobelco, Hitachi, Volvo, JCB, Hyundai, Doosan, Case, Liebherr, Takeuchi, Yanmar, Kubota e muitas outras.",
        faq2q: "Como encontro peças para minha máquina?",
        faq2a:
          "Selecione a marca e depois o modelo exato na lista alfabética. Cada página de modelo lista todos os componentes disponíveis.",
        faq3q: "Como obtenho preços?",
        faq3a:
          "Abra qualquer página de peça e envie o formulário de cotação. Nossa equipe responde com preço e disponibilidade.",
        faq4q: "As peças são de qualidade OEM?",
        faq4a:
          "Todas as peças são fabricadas conforme especificações OEM em aços ao boro e ligados, com superfícies temperadas e conjuntos lubrificados para a vida toda.",
      },
      company: {
        h1a: "Feito para os terrenos",
        h1b: "mais duros do mundo.",
        heroSub:
          "A VANROCK Track Solutions é a divisão de material rodante da VANROCK Group — engenharia, forjamento e usinagem de sistemas de esteiras para as principais marcas do mundo, atendendo revendedores e frotas em todo o mundo.",
        visitGlobal: "Visite nosso site global ↗",
        s1: "Marcas de máquinas cobertas",
        s2: "Peças projetadas e catalogadas",
        s3: "Modelos de máquinas suportados",
        s4: "Qualidade inspecionada antes do envio",
        madeKicker: "Made In VANROCK",
        madeT1: "Projetado, forjado e",
        madeT2: "acabado internamente.",
        madeT3: "Controle do início ao fim.",
        madeSub:
          "Nossa manufatura é verticalmente integrada em todo o ciclo de produção — forjamento, fundição e estampagem, usinagem de precisão, tratamentos térmicos e montagem de correntes. O investimento contínuo na automação de processos nos dá supervisão direta da qualidade e da continuidade do fornecimento em cada etapa, enquanto um programa próprio de pesquisa e desenvolvimento impulsiona a expansão contínua da nossa gama — projetada para desempenhar, competitiva em preço e alinhada às exigências de um mercado em evolução.",
        mp1: "Forjamento, usinagem e tratamento térmico próprios",
        mp2: "Inspeção de qualidade 100% antes do envio",
        mp3: "Materiais OEM, rastreáveis à origem",
        mp4: "Preço direto de fábrica — sem intermediários",
        whKicker: "Armazém Global",
        whT1: "Inventário global.",
        whT2: "Disponibilidade imediata.",
        whSub:
          "Os nossos armazéns mantêm milhares de roletes, rodas-guia, correntes e sapatas em estoque permanente, prontos para expedição mundial assim que o pedido é confirmado.",
        mapKicker: "Presença Global",
        mapTitle: "Uma marca. Todos os continentes.",
        mapDesc: "A VANROCK opera através de quatro escritórios regionais em Munique, Fort Worth, Dandenong e Ludhiana — apoiando revendedores na Europa, América do Norte, Austrália e Ásia com contactos locais, fusos horários locais e uma rede de stock partilhada.",
        mapSub:
          "As peças VANROCK trabalham em máquinas em obras e minas de todo o mundo — por meio da nossa rede de revendedores e exportação direta.",
        ms1: "Países atendidos",
        ms2: "Continentes",
        ms3: "Resposta de cotação",
        ms4: "Envio mundial",
        galKicker: "Inside VANROCK",
        galTitle: "Armazém",
        teamKicker: "As Nossas Pessoas",
        teamTitle: "Uma equipa. Um padrão.",
        teamSub: "Por trás de cada componente VANROCK está uma equipa de engenheiros, especialistas de produção e suporte a distribuidores que trabalha segundo o mesmo padrão — na fábrica e no terreno.",
        factsTitle: "Factos e números",
        scroll: "Rolar →",
      },
      dealer: {
        heroT1: "Seja um revendedor",
        heroT2: "hoje.",
        heroSub:
          "A gama completa de material rodante VANROCK — de correntes e roletes a esteiras de borracha e sapatas de borracha — é vendida por meio de uma rede protegida de revendedores. Se você distribui peças de material rodante no seu mercado, ou quer começar, este programa é para você.",
        b1t: "Preço direto do fabricante",
        b1x: "Compre diretamente da VANROCK — sem intermediários nem margens, a verdadeiras tarifas de fabricante.",
        b2t: "Proteção de território",
        b2x: "Limitamos o número de revendedores por região para proteger seu investimento na marca VANROCK.",
        b3t: "Estoque prioritário",
        b3x: "Revendedores têm acesso prioritário às produções e ao estoque reservado das peças de alto giro.",
        b4t: "Apoio de marketing",
        b4x: "Catálogos co-branded, fichas técnicas, fotografia e apoio de lançamento para o seu mercado local.",
        b5t: "Envio consolidado",
        b5x: "Peças entregues diretamente na sua porta. A VANROCK cuida de todo o envio, alfândega e impostos — tão fácil quanto comprar online.",
        b6t: "Rede global",
        b6x: "Junte-se a revendedores dos mercados de construção e mineração, apoiados pelo grupo VANROCK Group.",
        howKicker: "Como Funciona",
        howTitle: "Da candidatura ao primeiro envio",
        st1t: "Candidate-se",
        st1x: "Preencha o formulário com os dados da sua empresa e o território-alvo.",
        st2t: "Análise",
        st2x: "Nossa equipe analisa a candidatura — normalmente em 2 dias úteis.",
        st3t: "Acordo",
        st3x: "Acordamos território, faixa de preço e primeiro pedido junto com seu gerente dedicado.",
        st4t: "Lançamento",
        st4x: "Você recebe catálogos, materiais de marketing e o primeiro envio — e começa a vender VANROCK.",
        regKicker: "Registro",
        regTitle: "Registro de revendedor",
        regSub:
          "Os campos marcados com * são obrigatórios. Nossa equipe responde em 2 dias úteis.",
        lCompany: "Nome da empresa *",
        lContact: "Pessoa de contato *",
        lEmail: "Email *",
        lPhone: "Telefone *",
        lCountry: "País *",
        lCity: "Cidade / região",
        lWebsite: "Site da empresa",
        lType: "Tipo de negócio",
        lYears: "Anos de atividade",
        lVolume: "Volume mensal esperado",
        lBrands: "Marcas de máquinas atendidas",
        lMessage: "Conte-nos sobre seu mercado",
        selectCountry: "Selecionar país…",
        select: "Selecionar…",
        submit: "Enviar candidatura →",
        submitting: "Enviando…",
        okTitle: "Candidatura recebida.",
        okText:
          "Obrigado. Nossa equipe analisará sua candidatura para {{country}} e entrará em contato em {{email}} em 2 dias úteis.",
      },
      chat: {
        teaser:
          "Precisa de ajuda para encontrar a peça certa? Pergunte-me — conheço todas as 48.000+ peças.",
        status: "Online — responde em segundos",
        headerStatus: "Especialista em peças — responde em segundos",
        q1: "Encontrar peças para minha máquina",
        q1h: "ex. CAT 320, Komatsu PC200",
        q2: "Perguntar sobre preços",
        q2h: "Condições comerciais e disponibilidade",
        q3: "Como obtenho uma cotação?",
        q3h: "Resposta rápida de vendas",
        hi: "Olá, sou seu especialista em peças.",
        hiSub:
          "Diga a marca e o modelo da sua máquina — encontro as peças certas e ajudo com a cotação.",
        placeholder: "ex. Corrente para CAT D6D…",
        nowShowing: "Exibindo:",
      },
    },
  },
  nl: {
    translation: {
      nav: {
        quote: "Offerte",
        brands: "Merken",
        search: "Onderdelen Zoeken",
        company: "Bedrijf",
        searchPlaceholder: "ZOEK: MERK MODEL ONDERDEEL",
        insights: "Bedrijfsinformatie en inzichten",
      },
      footer: {
        blurb:
          "<0>VANROCK Track Solutions</0> is onderdeel van <1>VANROCK Group</1> — een wereldwijde groep die onderwagensystemen produceert voor graafmachines, minigravers, bulldozers en laders van 350+ machinemerken.",
        visitGlobal: "Bezoek onze wereldwijde website — vanrockglobal.com ↗",
        tagline: "Premium onderwagenonderdelen. Gebouwd om lang mee te gaan.",
        catalog: "Catalogus",
        company: "Bedrijf",
        contact: "Contact",
        allBrands: "Alle merken",
        partSearch: "Onderdelen zoeken",
        becomeDealer: "Word dealer →",
        rights: "Alle rechten voorbehouden",
        admin: "Admin Toegang",
      },
      home: {
        kicker: "Een bedrijf van",
        kickerCompany: "",
        h1a: "Vind het exacte",
        h1b: "onderwagen-",
        h1c: "onderdeel.",
        heroSub:
          "Looprollen, draagrollen, kettingwielsegmenten, kettingen, platen, bouten en moeren — voor {{brands}} merken en {{models}} machinemodellen.",
        searchBtn: "Zoeken",
        try: "Probeer:",
        statBrands: "Merken",
        statModels: "Modellen",
        statParts: "Onderdelen",
        browseKicker: "Catalogus Bekijken",
        brandIndex: "Merkenindex",
        allN: "Alle {{n}} →",
        modelsWord: "MODELLEN",
        topBrands: "Meest gecatalogiseerde merken",
        azBrands: "Alle merken A–Z",
        browseAz: "Bekijk alle {{n}} merken van A–Z",
        compKicker: "Componenten",
        compTitle: "Elk onderwagencomponent",
        f1t: "OEM-specificatie",
        f1x: "Borium- en gelegeerd staal, diep geharde slijtvlakken, afgedicht en levenslang gesmeerd.",
        f2t: "Snelle wereldwijde levering",
        f2x: "Onderdelen verzonden uit voorraad. Leveringsofferte inbegrepen bij elke aanbieding.",
        f3t: "Gratis technische ondersteuning",
        f3x: "Stuur ons uw serienummer en onze specialisten vinden het exacte onderdeel.",
        dealerKicker: "Dealer Programma",
        dealerT1: "Zet",
        dealerT2: "in uw schappen.",
        dealerSub:
          "Constante kwaliteit, diepe voorraad en directe fabrikantprijzen — alles wat een dealer nodig heeft. Sluit u aan bij het VANROCK-dealernetwerk in uw regio.",
        dp1: "+ Directe fabrikantprijzen",
        dp2: "+ Gebiedsbescherming",
        dp3: "+ Marketingondersteuning",
        dp4: "+ Prioritaire voorraadtoewijzing",
        dealerCta: "Word dealer →",
        faqKicker: "FAQ",
        faqTitle: "Veelgestelde vragen",
        faq1q: "Welke machinemerken dekken jullie af?",
        faq1a:
          "Wij hebben onderwagenonderdelen voor 350+ merken, waaronder Caterpillar, Komatsu, Kobelco, Hitachi, Volvo, JCB, Hyundai, Doosan, Case, Liebherr, Takeuchi, Yanmar, Kubota en vele anderen.",
        faq2q: "Hoe vind ik onderdelen voor mijn machine?",
        faq2a:
          "Selecteer uw merk en vervolgens uw exacte model uit de alfabetische lijst. Elke modelpagina toont alle beschikbare onderwagencomponenten.",
        faq3q: "Hoe krijg ik prijzen?",
        faq3a:
          "Open een onderdeelpagina en verstuur het offerteformulier. Ons team reageert binnen één werkdag met prijs en beschikbaarheid.",
        faq4q: "Zijn de onderdelen van OEM-kwaliteit?",
        faq4a:
          "Alle onderdelen worden volgens OEM-specificaties vervaardigd uit borium- en gelegeerde staalsoorten, met diep geharde slijtvlakken en levenslang gesmeerde samenstellingen.",
      },
      company: {
        h1a: "Gebouwd voor de zwaarste",
        h1b: "terreinen ter wereld.",
        heroSub:
          "VANROCK Track Solutions is de onderwagendivisie van VANROCK Group — wij ontwerpen, smeden en bewerken rupssystemen voor 's werelds toonaangevende machinemerken en leveren aan dealers en vloten wereldwijd.",
        visitGlobal: "Bezoek onze wereldwijde website ↗",
        s1: "Machinemerken gedekt",
        s2: "Onderdelen ontworpen & gecatalogiseerd",
        s3: "Machinemodellen ondersteund",
        s4: "Kwaliteit geïnspecteerd vóór verzending",
        madeKicker: "Made In VANROCK",
        madeT1: "Alle onderdelen 100% gemaakt in",
        madeT2: "VANROCK's eigen fabriek.",
        madeT3: "Geen uitbesteding.",
        madeSub:
          "Van ruw boriumstaal tot afgewerkt component: het hele proces vindt plaats onder één dak — kwaliteit wordt bij elke stap gecontroleerd.",
        mp1: "Eigen smederij, bewerking & warmtebehandeling",
        mp2: "100% kwaliteitsinspectie vóór verzending",
        mp3: "OEM-materialen, traceerbaar tot de bron",
        mp4: "Directe fabrieksprijzen — geen tussenpersonen",
        whKicker: "Wereldwijd Magazijn",
        whT1: "Diepe voorraad.",
        whT2: "Snelle verzending.",
        whSub:
          "Duizenden rollen, leiwielen, kettingen en platen altijd op voorraad — klaar voor verzending zodra uw bestelling is bevestigd.",
        mapKicker: "Wereldwijde Aanwezigheid",
        mapTitle: "Eén merk. Elk continent.",
        mapDesc: "VANROCK werkt via vier regionale kantoren in München, Fort Worth, Dandenong en Ludhiana — en ondersteunt dealers in Europa, Noord-Amerika, Australië en Azië met lokale contacten, lokale tijdzones en één gedeeld voorraadnetwerk.",
        mapSub:
          "VANROCK-onderdelen draaien op machines op bouw- en mijnlocaties wereldwijd — via ons dealernetwerk en directe export.",
        ms1: "Landen bediend",
        ms2: "Continenten",
        ms3: "Offertereactie",
        ms4: "Wereldwijde verzending",
        galKicker: "Inside VANROCK",
        galTitle: "Productie & magazijn",
        teamKicker: "Onze Mensen",
        teamTitle: "Eén team. Eén standaard.",
        teamSub: "Achter elk VANROCK-onderdeel staat een team van ingenieurs, productiespecialisten en dealerondersteuning dat volgens dezelfde standaard werkt — in de fabriek en in het veld.",
        factsTitle: "Feiten & cijfers",
        scroll: "Scroll →",
      },
      dealer: {
        heroT1: "Word vandaag",
        heroT2: "dealer.",
        heroSub:
          "VANROCK-kettingen, platen, rollen, leiwielen en kettingwielen worden verkocht via een beschermd dealernetwerk. Distribueert u onderwagenonderdelen in uw markt, dan is dit programma voor u gemaakt.",
        b1t: "Directe fabrikantprijzen",
        b1x: "Koop rechtstreeks bij VANROCK — zonder tussenpersonen of marges, tegen echte fabrikanttarieven.",
        b2t: "Gebiedsbescherming",
        b2x: "Wij beperken het aantal dealers per regio zodat uw investering in het merk VANROCK beschermd is.",
        b3t: "Prioritaire voorraad",
        b3x: "Dealers krijgen als eerste toegang tot productieruns en gereserveerde voorraad van snellopende onderdelen.",
        b4t: "Marketingondersteuning",
        b4x: "Co-branded catalogi, productbladen, fotografie en lanceringsondersteuning voor uw lokale markt.",
        b5t: "Geconsolideerde verzending",
        b5x: "Volledige-container- en gemengde consolidatie vanuit ons magazijn met exportdocumentatie geregeld.",
        b6t: "Wereldwijd netwerk",
        b6x: "Sluit u aan bij dealers in bouw- en mijnbouwmarkten, gesteund door de VANROCK Group-groep.",
        howKicker: "Hoe Het Werkt",
        howTitle: "Van aanmelding tot eerste zending",
        st1t: "Aanmelden",
        st1x: "Vul het formulier in met uw bedrijfsgegevens en doelgebied.",
        st2t: "Beoordeling",
        st2x: "Ons team beoordeelt uw aanmelding — meestal binnen 2 werkdagen.",
        st3t: "Overeenkomst",
        st3x: "We spreken gebied, prijsniveau en eerste bestelling af met uw vaste manager.",
        st4t: "Lancering",
        st4x: "U ontvangt catalogi, marketingmateriaal en uw eerste zending — en begint VANROCK te verkopen.",
        regKicker: "Registratie",
        regTitle: "Dealerregistratie",
        regSub:
          "Velden met * zijn verplicht. Ons team reageert binnen 2 werkdagen.",
        lCompany: "Bedrijfsnaam *",
        lContact: "Contactpersoon *",
        lEmail: "E-mail *",
        lPhone: "Telefoon *",
        lCountry: "Land *",
        lCity: "Stad / regio",
        lWebsite: "Bedrijfswebsite",
        lType: "Type bedrijf",
        lYears: "Jaren actief",
        lVolume: "Verwacht maandvolume",
        lBrands: "Bediende machinemerken",
        lMessage: "Vertel ons over uw markt",
        selectCountry: "Selecteer land…",
        select: "Selecteer…",
        submit: "Aanmelding versturen →",
        submitting: "Versturen…",
        okTitle: "Aanmelding ontvangen.",
        okText:
          "Bedankt. Ons team beoordeelt uw aanmelding voor {{country}} en neemt binnen 2 werkdagen contact op via {{email}}.",
      },
      chat: {
        teaser:
          "Hulp nodig bij het vinden van het juiste onderdeel? Vraag het mij — ik ken alle 48.000+ onderdelen.",
        status: "Online — reageert binnen seconden",
        headerStatus: "Onderdelenexpert — reageert in seconden",
        q1: "Onderdelen voor mijn machine vinden",
        q1h: "bijv. CAT 320, Komatsu PC200",
        q2: "Vraag naar prijzen",
        q2h: "Commerciële voorwaarden en beschikbaarheid",
        q3: "Hoe krijg ik een offerte?",
        q3h: "Snelle reactie van verkoop",
        hi: "Hallo, ik ben uw onderdelenexpert.",
        hiSub:
          "Vertel me het merk en model van uw machine — ik vind de juiste onderdelen en help u aan een offerte.",
        placeholder: "bijv. Ketting voor CAT D6D…",
        nowShowing: "Nu getoond:",
      },
    },
  },
  pl: {
    translation: {
      nav: {
        quote: "Wycena",
        brands: "Marki",
        search: "Szukaj Części",
        company: "Firma",
        searchPlaceholder: "SZUKAJ: MARKA MODEL CZĘŚĆ",
        insights: "Informacje i aktualności o firmie",
      },
      footer: {
        blurb:
          "<0>VANROCK Track Solutions</0> jest częścią <1>VANROCK Group</1> — światowej grupy produkującej systemy podwozi gąsienicowych do koparek, minikoparek, spycharek i ładowarek dla ponad 270 marek maszyn.",
        visitGlobal: "Odwiedź naszą globalną stronę — vanrockglobal.com ↗",
        tagline: "Części podwozia premium. Stworzone, by przetrwać.",
        catalog: "Katalog",
        company: "Firma",
        contact: "Kontakt",
        allBrands: "Wszystkie marki",
        partSearch: "Wyszukiwarka części",
        becomeDealer: "Zostań dealerem →",
        rights: "Wszelkie prawa zastrzeżone",
        admin: "Dostęp Admin",
      },
      home: {
        kicker: "Firma grupy",
        kickerCompany: "",
        h1a: "Znajdź dokładnie tę",
        h1b: "część podwozia,",
        h1c: "której szukasz.",
        heroSub:
          "Rolki jezdne, rolki podtrzymujące, segmenty kół napędowych, łańcuchy, płyty, śruby i nakrętki — dla {{brands}} marek i {{models}} modeli maszyn.",
        searchBtn: "Szukaj",
        try: "Wypróbuj:",
        statBrands: "Marki",
        statModels: "Modele",
        statParts: "Części",
        browseKicker: "Przeglądaj Katalog",
        brandIndex: "Indeks marek",
        allN: "Wszystkie {{n}} →",
        modelsWord: "MODELI",
        topBrands: "Najczęściej katalogowane marki",
        azBrands: "Wszystkie marki A–Z",
        compKicker: "Komponenty",
        compTitle: "Każdy element podwozia gąsienicowego",
        f1t: "Specyfikacja OEM",
        f1x: "Stal borowa i stopowa, głęboko hartowane powierzchnie robocze, uszczelnione i dożywotnio nasmarowane.",
        f2t: "Szybka dostawa na cały świat",
        f2x: "Części wysyłane z magazynu. Wycena dostawy dołączona do każdej oferty.",
        f3t: "Bezpłatne wsparcie techniczne",
        f3x: "Prześlij nam numer seryjny, a nasi specjaliści dopasują dokładną część.",
        dealerKicker: "Program Dealerski",
        dealerT1: "Postaw",
        dealerT2: "na swojej półce.",
        dealerSub:
          "Stała jakość, głębokie stany magazynowe i ceny bezpośrednio od producenta — wszystko, czego potrzebuje dealer. Dołącz do sieci dealerów VANROCK w swoim regionie.",
        dp1: "+ Ceny bezpośrednio od producenta",
        dp2: "+ Ochrona terytorium",
        dp3: "+ Wsparcie marketingowe",
        dp4: "+ Priorytetowy przydział towaru",
        dealerCta: "Zostań dealerem →",
        faqKicker: "FAQ",
        faqTitle: "Najczęstsze pytania",
        faq1q: "Jakie marki maszyn obsługujecie?",
        faq1a:
          "Mamy części podwozia dla ponad 270 marek, w tym Caterpillar, Komatsu, Kobelco, Hitachi, Volvo, JCB, Hyundai, Doosan, Case, Liebherr, Takeuchi, Yanmar, Kubota i wielu innych.",
        faq2q: "Jak znaleźć części do mojej maszyny?",
        faq2a:
          "Wybierz markę, a następnie dokładny model z listy alfabetycznej. Każda strona modelu zawiera wszystkie dostępne komponenty podwozia.",
        faq3q: "Jak otrzymać ceny?",
        faq3a:
          "Otwórz stronę części i wyślij formularz wyceny. Nasz zespół odpowiada w ciągu jednego dnia roboczego z ceną i dostępnością.",
        faq4q: "Czy części są jakości OEM?",
        faq4a:
          "Wszystkie części są produkowane zgodnie ze specyfikacjami OEM ze stali borowych i stopowych, z hartowanymi powierzchniami i dożywotnio smarowanymi zespołami.",
      },
      company: {
        h1a: "Stworzone na najtwardsze",
        h1b: "tereny świata.",
        heroSub:
          "VANROCK Track Solutions to dział podwozi gąsienicowych VANROCK Group — projektujemy, kujemy i obrabiamy systemy gąsienic dla czołowych światowych marek maszyn, obsługując dealerów i floty na całym świecie.",
        visitGlobal: "Odwiedź globalną stronę ↗",
        s1: "Obsługiwane marki maszyn",
        s2: "Zaprojektowane i skatalogowane części",
        s3: "Obsługiwane modele maszyn",
        s4: "Kontrola jakości przed wysyłką",
        madeKicker: "Made In VANROCK",
        madeT1: "Wszystkie części w 100% wykonane we",
        madeT2: "własnej fabryce VANROCK.",
        madeT3: "Bez outsourcingu.",
        madeSub:
          "Od surowej stali borowej po gotowy komponent — cały proces odbywa się pod jednym dachem, a jakość jest kontrolowana na każdym etapie.",
        mp1: "Własne kucie, obróbka i obróbka cieplna",
        mp2: "100% kontrola jakości przed wysyłką",
        mp3: "Materiały OEM, identyfikowalne do źródła",
        mp4: "Ceny prosto z fabryki — bez pośredników",
        whKicker: "Globalny Magazyn",
        whT1: "Głębokie stany.",
        whT2: "Szybka wysyłka.",
        whSub:
          "Tysiące rolek, kół napinających, łańcuchów i płyt zawsze na półce — gotowe do wysyłki w chwili potwierdzenia zamówienia.",
        mapKicker: "Globalna Obecność",
        mapTitle: "Jedna marka. Każdy kontynent.",
        mapDesc: "VANROCK działa poprzez cztery biura regionalne w Monachium, Fort Worth, Dandenong i Ludhianie — wspierając dealerów w Europie, Ameryce Północnej, Australii i Azji lokalnymi kontaktami, lokalnymi strefami czasowymi i wspólną siecią magazynową.",
        mapSub:
          "Części VANROCK pracują w maszynach na budowach i w kopalniach na całym świecie — poprzez naszą sieć dealerów i eksport bezpośredni.",
        ms1: "Obsługiwane kraje",
        ms2: "Kontynenty",
        ms3: "Odpowiedź na wycenę",
        ms4: "Wysyłka na cały świat",
        galKicker: "Inside VANROCK",
        galTitle: "Produkcja i magazyn",
        teamKicker: "Nasi Ludzie",
        teamTitle: "Jeden zespół. Jeden standard.",
        teamSub: "Za każdym komponentem VANROCK stoi zespół inżynierów, specjalistów produkcji i wsparcia dealerów, pracujący według tego samego standardu — w zakładzie i w terenie.",
        factsTitle: "Fakty i liczby",
        scroll: "Przewiń →",
      },
      dealer: {
        heroT1: "Zostań dealerem",
        heroT2: "już dziś.",
        heroSub:
          "Łańcuchy, płyty, rolki, koła napinające i koła napędowe VANROCK sprzedawane są poprzez chronioną sieć dealerów. Jeśli dystrybuujesz części podwozia na swoim rynku, ten program jest dla Ciebie.",
        b1t: "Ceny bezpośrednio od producenta",
        b1x: "Kupuj bezpośrednio od VANROCK — bez pośredników i marż, po prawdziwych cenach producenta.",
        b2t: "Ochrona terytorium",
        b2x: "Ograniczamy liczbę dealerów w regionie, aby chronić Twoją inwestycję w markę VANROCK.",
        b3t: "Priorytetowy przydział towaru",
        b3x: "Dealerzy mają pierwszeństwo dostępu do produkcji i zarezerwowanych stanów szybko rotujących części.",
        b4t: "Wsparcie marketingowe",
        b4x: "Katalogi co-brandowe, karty produktów, fotografia i wsparcie startu na Twoim lokalnym rynku.",
        b5t: "Wysyłka skonsolidowana",
        b5x: "Konsolidacja pełnokontenerowa i mieszana z naszego magazynu z załatwioną dokumentacją eksportową.",
        b6t: "Globalna sieć",
        b6x: "Dołącz do dealerów rynków budowlanych i górniczych, wspieranych przez grupę VANROCK Group.",
        howKicker: "Jak To Działa",
        howTitle: "Od zgłoszenia do pierwszej dostawy",
        st1t: "Zgłoś się",
        st1x: "Wypełnij formularz danymi firmy i docelowym terytorium.",
        st2t: "Weryfikacja",
        st2x: "Nasz zespół weryfikuje zgłoszenie — zwykle w ciągu 2 dni roboczych.",
        st3t: "Umowa",
        st3x: "Wspólnie z dedykowanym opiekunem ustalamy terytorium, poziom cen i pierwsze zamówienie.",
        st4t: "Start",
        st4x: "Otrzymujesz katalogi, materiały marketingowe i pierwszą dostawę — i zaczynasz sprzedawać VANROCK.",
        regKicker: "Rejestracja",
        regTitle: "Rejestracja dealera",
        regSub:
          "Pola oznaczone * są wymagane. Nasz zespół odpowiada w ciągu 2 dni roboczych.",
        lCompany: "Nazwa firmy *",
        lContact: "Osoba kontaktowa *",
        lEmail: "Email *",
        lPhone: "Telefon *",
        lCountry: "Kraj *",
        lCity: "Miasto / region",
        lWebsite: "Strona firmowa",
        lType: "Typ działalności",
        lYears: "Lata działalności",
        lVolume: "Przewidywany miesięczny wolumen",
        lBrands: "Obsługiwane marki maszyn",
        lMessage: "Opowiedz nam o swoim rynku",
        selectCountry: "Wybierz kraj…",
        select: "Wybierz…",
        submit: "Wyślij zgłoszenie →",
        submitting: "Wysyłanie…",
        okTitle: "Zgłoszenie otrzymane.",
        okText:
          "Dziękujemy. Nasz zespół przeanalizuje zgłoszenie dla kraju {{country}} i skontaktuje się pod adresem {{email}} w ciągu 2 dni roboczych.",
      },
      chat: {
        teaser:
          "Potrzebujesz pomocy w znalezieniu właściwej części? Zapytaj mnie — znam wszystkie 48 000+ części.",
        status: "Online — odpowiada w kilka sekund",
        headerStatus: "Ekspert części — odpowiada w sekundach",
        q1: "Znajdź części do mojej maszyny",
        q1h: "np. CAT 320, Komatsu PC200",
        q2: "Zapytaj o ceny",
        q2h: "Warunki handlowe i dostępność",
        q3: "Jak otrzymać wycenę?",
        q3h: "Szybka odpowiedź działu sprzedaży",
        hi: "Cześć, jestem Twoim ekspertem od części.",
        hiSub:
          "Podaj markę i model maszyny — znajdę właściwe części i pomogę w wycenie.",
        placeholder: "np. Łańcuch do CAT D6D…",
        nowShowing: "Wyświetlana strona:",
      },
    },
  },
  tr: {
    translation: {
      nav: {
        quote: "Teklif",
        brands: "Markalar",
        search: "Parça Ara",
        company: "Şirket",
        searchPlaceholder: "ARA: MARKA MODEL PARÇA",
        insights: "Şirket bilgileri ve içgörüler",
      },
      footer: {
        blurb:
          "<0>VANROCK Track Solutions</0>, <1>VANROCK Group</1>'in bir parçasıdır — ekskavatörler, mini ekskavatörler, dozerler ve yükleyiciler için 350+ makine markasına yürüyüş takımı sistemleri üreten küresel bir grup.",
        visitGlobal: "Küresel web sitemizi ziyaret edin — vanrockglobal.com ↗",
        tagline:
          "Premium yürüyüş takımı parçaları. Dayanıklılık için üretildi.",
        catalog: "Katalog",
        company: "Şirket",
        contact: "İletişim",
        allBrands: "Tüm markalar",
        partSearch: "Parça arama",
        becomeDealer: "Bayi olun →",
        rights: "Tüm hakları saklıdır",
        admin: "Admin Erişimi",
      },
      home: {
        kicker: "Bir",
        kickerCompany: "şirketi",
        h1a: "Tam ihtiyacınız olan",
        h1b: "yürüyüş takımı",
        h1c: "parçasını bulun.",
        heroSub:
          "Alt makaralar, taşıyıcı makaralar, cer dişlisi segmentleri, zincirler, paletler, cıvatalar ve somunlar — {{brands}} marka ve {{models}} makine modeli için.",
        searchBtn: "Ara",
        try: "Deneyin:",
        statBrands: "Marka",
        statModels: "Model",
        statParts: "Parça",
        browseKicker: "Kataloğa Gözat",
        brandIndex: "Marka dizini",
        allN: "Tümü {{n}} →",
        modelsWord: "MODEL",
        topBrands: "En çok kataloglanan markalar",
        azBrands: "Tüm markalar A–Z",
        compKicker: "Bileşenler",
        compTitle: "Her yürüyüş takımı bileşeni",
        f1t: "OEM spesifikasyonu",
        f1x: "Bor ve alaşımlı çelik, derin sertleştirilmiş aşınma yüzeyleri, sızdırmaz ve ömür boyu yağlanmış.",
        f2t: "Hızlı dünya çapında teslimat",
        f2x: "Parçalar stoktan sevk edilir. Her teklifte teslimat fiyatı dahildir.",
        f3t: "Ücretsiz teknik destek",
        f3x: "Seri numaranızı gönderin, uzmanlarımız tam parçayı eşleştirsin.",
        dealerKicker: "Bayi Programı",
        dealerT1: "Rafınıza",
        dealerT2: "koyun.",
        dealerSub:
          "İstikrarlı kalite, derin stok ve doğrudan üretici fiyatları — bir bayinin ihtiyacı olan her şey. Bölgenizdeki VANROCK bayi ağına katılın.",
        dp1: "+ Doğrudan üretici fiyatları",
        dp2: "+ Bölge koruması",
        dp3: "+ Pazarlama desteği",
        dp4: "+ Öncelikli stok tahsisi",
        dealerCta: "Bayi olun →",
        faqKicker: "SSS",
        faqTitle: "Sıkça sorulan sorular",
        faq1q: "Hangi makine markalarını kapsıyorsunuz?",
        faq1a:
          "Caterpillar, Komatsu, Kobelco, Hitachi, Volvo, JCB, Hyundai, Doosan, Case, Liebherr, Takeuchi, Yanmar, Kubota ve daha birçok marka dahil 350+ marka için yürüyüş takımı parçası stokluyoruz.",
        faq2q: "Makinem için parçaları nasıl bulurum?",
        faq2a:
          "Makine markanızı seçin, ardından alfabetik listeden tam modelinizi seçin. Her model sayfası mevcut tüm yürüyüş takımı bileşenlerini listeler.",
        faq3q: "Fiyatları nasıl alırım?",
        faq3a:
          "Herhangi bir parça sayfasını açın ve Teklif İste formunu gönderin. Ekibimiz bir iş günü içinde fiyat ve stok durumuyla yanıt verir.",
        faq4q: "Parçalar OEM kalitesinde mi?",
        faq4a:
          "Tüm parçalar bor ve alaşımlı çeliklerden OEM spesifikasyonlarına göre üretilir; derin sertleştirilmiş aşınma yüzeyleri ve ömür boyu yağlanmış gruplarla.",
      },
      company: {
        h1a: "Dünyanın en zorlu",
        h1b: "zeminleri için üretildi.",
        heroSub:
          "VANROCK Track Solutions, VANROCK Group'in yürüyüş takımı bölümüdür — dünyanın önde gelen makine markaları için palet sistemleri tasarlar, döver ve işler; dünya çapında bayilere ve filolara hizmet verir.",
        visitGlobal: "Küresel siteyi ziyaret edin ↗",
        s1: "Kapsanan makine markası",
        s2: "Tasarlanan ve kataloglanan parça",
        s3: "Desteklenen makine modeli",
        s4: "Sevkiyat öncesi kalite kontrolü",
        madeKicker: "Made In VANROCK",
        madeT1: "Tüm parçalar %100",
        madeT2: "VANROCK'un kendi fabrikasında.",
        madeT3: "Dış kaynak yok.",
        madeSub:
          "Ham bor çeliğinden bitmiş bileşene kadar tüm süreç tek çatı altında gerçekleşir — kalite her adımda kontrol edilir.",
        mp1: "Şirket içi dövme, işleme ve ısıl işlem",
        mp2: "Sevkiyat öncesi %100 kalite kontrolü",
        mp3: "Kaynağına kadar izlenebilir OEM malzemeler",
        mp4: "Fabrikadan doğrudan fiyatlar — aracı yok",
        whKicker: "Küresel Depo",
        whT1: "Derin stok.",
        whT2: "Hızlı sevkiyat.",
        whSub:
          "Binlerce makara, istikamet tekeri, zincir ve palet her zaman rafta — siparişiniz onaylandığı anda dünya çapında sevkiyata hazır.",
        mapKicker: "Küresel Varlık",
        mapTitle: "Tek marka. Her kıta.",
        mapDesc: "VANROCK, Münih, Fort Worth, Dandenong ve Ludhiana'daki dört bölge ofisiyle faaliyet gösterir — Avrupa, Kuzey Amerika, Avustralya ve Asya'daki bayilere yerel iletişim, yerel saat dilimleri ve ortak bir stok ağıyla destek verir.",
        mapSub:
          "VANROCK parçaları, bayi ağımız ve doğrudan ihracat yoluyla dünya çapındaki inşaat ve maden sahalarındaki makinelerde çalışıyor.",
        ms1: "Hizmet verilen ülke",
        ms2: "Kıta",
        ms3: "Teklif yanıtı",
        ms4: "Dünya çapında sevkiyat",
        galKicker: "Inside VANROCK",
        galTitle: "Üretim ve depo",
        teamKicker: "Ekibimiz",
        teamTitle: "Tek ekip. Tek standart.",
        teamSub: "Her VANROCK bileşeninin arkasında, fabrikada ve sahada aynı standartla çalışan mühendisler, üretim uzmanları ve bayi destek ekibi vardır.",
        factsTitle: "Rakamlarla biz",
        scroll: "Kaydır →",
      },
      dealer: {
        heroT1: "Bugün",
        heroT2: "bayisi olun.",
        heroSub:
          "VANROCK zincirleri, paletleri, makaraları, istikamet tekerleri ve cer dişlileri korumalı bir bayi ağı üzerinden satılır. Pazarınızda yürüyüş takımı parçaları dağıtıyorsanız, bu program sizin için tasarlandı.",
        b1t: "Doğrudan üretici fiyatları",
        b1x: "Doğrudan VANROCK'tan satın alın — aracı ve kâr marjı yok, gerçek üretici fiyatlarıyla.",
        b2t: "Bölge koruması",
        b2x: "VANROCK markasına yaptığınız yatırımı korumak için bölge başına bayi sayısını sınırlıyoruz.",
        b3t: "Öncelikli stok tahsisi",
        b3x: "Bayiler, hızlı hareket eden parçaların üretim serilerine ve ayrılmış stoklarına öncelikli erişim sağlar.",
        b4t: "Pazarlama desteği",
        b4x: "Yerel pazarınız için ortak markalı kataloglar, ürün veri sayfaları, fotoğraflar ve lansman desteği.",
        b5t: "Konsolide sevkiyat",
        b5x: "Depomuzdan tam konteyner ve karışık parça konsolidasyonu, ihracat belgeleri bizden.",
        b6t: "Küresel ağ",
        b6x: "VANROCK Group grubunun desteğiyle inşaat ve maden pazarlarındaki bayilere katılın.",
        howKicker: "Nasıl Çalışır",
        howTitle: "Başvurudan ilk sevkiyata",
        st1t: "Başvurun",
        st1x: "Aşağıdaki formu şirket bilgileriniz ve hedef bölgenizle doldurun.",
        st2t: "İnceleme",
        st2x: "Bayi ekibimiz başvurunuzu inceler — genellikle 2 iş günü içinde.",
        st3t: "Anlaşma",
        st3x: "Bölge, fiyat seviyesi ve ilk stok siparişini size özel yöneticinizle birlikte belirleriz.",
        st4t: "Başlangıç",
        st4x: "Kataloglar, pazarlama materyalleri ve ilk sevkiyatınızı alırsınız — ve VANROCK satmaya başlarsınız.",
        regKicker: "Kayıt",
        regTitle: "Bayi kaydı",
        regSub:
          "* ile işaretli alanlar zorunludur. Ekibimiz 2 iş günü içinde yanıt verir.",
        lCompany: "Şirket adı *",
        lContact: "İlgili kişi *",
        lEmail: "E-posta *",
        lPhone: "Telefon *",
        lCountry: "Ülke *",
        lCity: "Şehir / bölge",
        lWebsite: "Şirket web sitesi",
        lType: "İş türü",
        lYears: "Faaliyet yılı",
        lVolume: "Beklenen aylık hacim",
        lBrands: "Hizmet verdiğiniz makine markaları",
        lMessage: "Pazarınızdan bahsedin",
        selectCountry: "Ülke seçin…",
        select: "Seçin…",
        submit: "Başvuruyu gönder →",
        submitting: "Gönderiliyor…",
        okTitle: "Başvuru alındı.",
        okText:
          "Teşekkürler. Ekibimiz {{country}} için başvurunuzu inceleyecek ve 2 iş günü içinde {{email}} adresinden sizinle iletişime geçecek.",
      },
      chat: {
        teaser:
          "Doğru parçayı bulmak için yardım mı lazım? Bana sorun — 48.000+ parçanın tümünü biliyorum.",
        status: "Çevrimiçi — saniyeler içinde yanıtlar",
        headerStatus: "Parça uzmanı — saniyeler içinde yanıtlar",
        q1: "Makinem için parça bul",
        q1h: "örn. CAT 320, Komatsu PC200",
        q2: "Fiyat sor",
        q2h: "Ticari koşullar ve stok durumu",
        q3: "Nasıl teklif alırım?",
        q3h: "Satıştan hızlı yanıt",
        hi: "Merhaba, ben parça uzmanınızım.",
        hiSub:
          "Makinenizin markasını ve modelini söyleyin — doğru parçaları bulur ve teklif almanıza yardımcı olurum.",
        placeholder: "örn. CAT D6D için zincir…",
        nowShowing: "Gösterilen:",
      },
    },
  },
  ru: {
    translation: {
      nav: {
        quote: "Расчёт цены",
        brands: "Бренды",
        search: "Поиск_Запчастей",
        company: "Компания",
        searchPlaceholder: "ПОИСК: БРЕНД / МОДЕЛЬ / ДЕТАЛЬ_",
        insights: "Информация о компании и аналитика",
      },
      footer: {
        blurb:
          "<0>VANROCK Track Solutions</0> входит в <1>VANROCK Group</1> — международную группу, производящую системы ходовой части для экскаваторов, мини-экскаваторов, бульдозеров и погрузчиков более чем 270 брендов техники.",
        visitGlobal: "Посетите наш глобальный сайт — vanrockglobal.com ↗",
        tagline: "Премиальные запчасти ходовой части. Созданы служить долго.",
        catalog: "Каталог",
        company: "Компания",
        contact: "Контакты",
        allBrands: "Все бренды",
        partSearch: "Поиск запчастей",
        becomeDealer: "Стать дилером →",
        rights: "Все права защищены",
        admin: "Админ_Доступ",
      },
      home: {
        kicker: "Компания группы",
        kickerCompany: "",
        h1a: "Найдите точную",
        h1b: "запчасть ходовой",
        h1c: "части.",
        heroSub:
          "Опорные катки, поддерживающие катки, сегменты ведущих колёс, цепи, башмаки, болты и гайки — для {{brands}} брендов и {{models}} моделей техники.",
        searchBtn: "Поиск",
        try: "Например:",
        statBrands: "Брендов",
        statModels: "Моделей",
        statParts: "Запчастей",
        browseKicker: "Каталог",
        brandIndex: "Индекс брендов",
        allN: "Все {{n}} →",
        modelsWord: "МОДЕЛЕЙ",
        topBrands: "Наиболее каталогизированные бренды",
        azBrands: "Все бренды A–Z",
        browseAz: "Смотреть все {{n}} брендов A–Z",
        compKicker: "Компоненты",
        compTitle: "Все компоненты ходовой части",
        f1t: "Спецификация OEM",
        f1x: "Борсодержащая и легированная сталь, глубоко закалённые поверхности износа, герметичные узлы со смазкой на весь срок службы.",
        f2t: "Быстрая доставка по всему миру",
        f2x: "Запчасти отгружаются со склада. Стоимость доставки включена в каждое предложение.",
        f3t: "Бесплатная техподдержка",
        f3x: "Отправьте нам серийный номер — наши специалисты подберут точную деталь.",
        dealerKicker: "Дилерская_Программа",
        dealerT1: "Поставьте",
        dealerT2: "на свою полку.",
        dealerSub:
          "Стабильное качество, большие складские запасы и цены напрямую от производителя — всё, что нужно дилеру. Присоединяйтесь к дилерской сети VANROCK в вашем регионе.",
        dp1: "+ Цены напрямую от производителя",
        dp2: "+ Защита территории",
        dp3: "+ Маркетинговая поддержка",
        dp4: "+ Приоритетное выделение товара",
        dealerCta: "Стать дилером →",
        faqKicker: "FAQ",
        faqTitle: "Частые вопросы",
        faq1q: "Какие бренды техники вы покрываете?",
        faq1a:
          "У нас есть запчасти ходовой части для более чем 270 брендов, включая Caterpillar, Komatsu, Kobelco, Hitachi, Volvo, JCB, Hyundai, Doosan, Case, Liebherr, Takeuchi, Yanmar, Kubota и многие другие.",
        faq2q: "Как найти запчасти для моей техники?",
        faq2a:
          "Выберите бренд, затем точную модель из алфавитного списка. На странице каждой модели перечислены все доступные компоненты ходовой части.",
        faq3q: "Как узнать цены?",
        faq3a:
          "Откройте страницу детали и отправьте форму запроса цены. Наша команда ответит в течение одного рабочего дня с ценой и наличием.",
        faq4q: "Запчасти соответствуют качеству OEM?",
        faq4a:
          "Все детали производятся по спецификациям OEM из борсодержащих и легированных сталей, с закалёнными поверхностями и узлами со смазкой на весь срок службы.",
      },
      company: {
        h1a: "Создано для самых суровых",
        h1b: "грунтов мира.",
        heroSub:
          "VANROCK Track Solutions — подразделение ходовых систем VANROCK Group: проектирование, ковка и механическая обработка гусеничных систем для ведущих мировых брендов техники, поставки дилерам и паркам по всему миру.",
        visitGlobal: "Посетить глобальный сайт ↗",
        s1: "Брендов техники охвачено",
        s2: "Деталей разработано и внесено в каталог",
        s3: "Моделей техники поддерживается",
        s4: "Контроль качества перед отгрузкой",
        madeKicker: "Made In VANROCK",
        madeT1: "Все детали на 100% сделаны на",
        madeT2: "собственном заводе VANROCK.",
        madeT3: "Без аутсорсинга.",
        madeSub:
          "От сырой борсодержащей стали до готового компонента — весь процесс происходит под одной крышей, качество контролируется на каждом шаге.",
        mp1: "Собственная ковка, обработка и термообработка",
        mp2: "100% контроль качества перед отгрузкой",
        mp3: "Материалы OEM с прослеживаемостью до источника",
        mp4: "Цены напрямую с завода — без посредников",
        whKicker: "Глобальный_Склад",
        whT1: "Большие запасы.",
        whT2: "Быстрая отгрузка.",
        whSub:
          "Тысячи катков, направляющих колёс, цепей и башмаков всегда на складе — готовы к отправке по всему миру сразу после подтверждения заказа.",
        mapKicker: "Глобальное_Присутствие",
        mapTitle: "Один бренд. Все континенты.",
        mapDesc: "VANROCK работает через четыре региональных офиса — в Мюнхене, Форт-Уэрте, Данденонге и Лудхияне, поддерживая дилеров в Европе, Северной Америке, Австралии и Азии локальными контактами, местными часовыми поясами и единой складской сетью.",
        mapSub:
          "Запчасти VANROCK работают на машинах на стройках и рудниках по всему миру — через нашу дилерскую сеть и прямой экспорт.",
        ms1: "Обслуживаемых стран",
        ms2: "Континентов",
        ms3: "Ответ на запрос",
        ms4: "Доставка по миру",
        galKicker: "Inside VANROCK",
        galTitle: "Производство и склад",
        teamKicker: "Наши_Люди",
        teamTitle: "Одна команда. Один стандарт.",
        teamSub: "За каждым компонентом VANROCK стоит команда инженеров, специалистов производства и поддержки дилеров, работающая по единому стандарту — на заводе и в полевых условиях.",
        factsTitle: "Цифры и факты",
        scroll: "Листайте →",
      },
      dealer: {
        heroT1: "Станьте дилером",
        heroT2: "уже сегодня.",
        heroSub:
          "Цепи, башмаки, катки, направляющие и ведущие колёса VANROCK продаются через защищённую дилерскую сеть. Если вы дистрибьютор запчастей ходовой части на своём рынке — эта программа для вас.",
        b1t: "Цены напрямую от производителя",
        b1x: "Покупайте напрямую у VANROCK — без посредников и наценок, по реальным ценам производителя.",
        b2t: "Защита территории",
        b2x: "Мы ограничиваем число дилеров в регионе, чтобы защитить ваши инвестиции в бренд VANROCK.",
        b3t: "Приоритетное выделение товара",
        b3x: "Дилеры получают первоочередной доступ к производственным партиям и зарезервированным запасам ходовых позиций.",
        b4t: "Маркетинговая поддержка",
        b4x: "Ко-брендированные каталоги, технические листы, фотографии и поддержка запуска на вашем рынке.",
        b5t: "Консолидированная доставка",
        b5x: "Полноконтейнерная и сборная консолидация с нашего склада с оформлением экспортных документов.",
        b6t: "Глобальная сеть",
        b6x: "Присоединяйтесь к дилерам строительных и горнодобывающих рынков при поддержке группы VANROCK Group.",
        howKicker: "Как_Это_Работает",
        howTitle: "От заявки до первой отгрузки",
        st1t: "Заявка",
        st1x: "Заполните форму ниже с данными компании и целевой территорией.",
        st2t: "Рассмотрение",
        st2x: "Наша команда рассматривает заявку — обычно в течение 2 рабочих дней.",
        st3t: "Соглашение",
        st3x: "Согласовываем территорию, ценовой уровень и первый заказ вместе с вашим персональным менеджером.",
        st4t: "Запуск",
        st4x: "Вы получаете каталоги, маркетинговые материалы и первую поставку — и начинаете продавать VANROCK.",
        regKicker: "Регистрация",
        regTitle: "Регистрация дилера",
        regSub:
          "Поля со * обязательны. Наша команда ответит в течение 2 рабочих дней.",
        lCompany: "Название компании *",
        lContact: "Контактное лицо *",
        lEmail: "Email *",
        lPhone: "Телефон *",
        lCountry: "Страна *",
        lCity: "Город / регион",
        lWebsite: "Сайт компании",
        lType: "Тип бизнеса",
        lYears: "Лет на рынке",
        lVolume: "Ожидаемый месячный объём",
        lBrands: "Обслуживаемые бренды техники",
        lMessage: "Расскажите о вашем рынке",
        selectCountry: "Выберите страну…",
        select: "Выберите…",
        submit: "Отправить заявку →",
        submitting: "Отправка…",
        okTitle: "Заявка получена.",
        okText:
          "Спасибо. Наша команда рассмотрит вашу заявку для {{country}} и свяжется с вами по адресу {{email}} в течение 2 рабочих дней.",
      },
      chat: {
        teaser:
          "Нужна помощь в подборе детали? Спросите меня — я знаю все 48 000+ запчастей.",
        status: "Онлайн — отвечает за секунды",
        headerStatus: "Эксперт по запчастям — отвечает за секунды",
        q1: "Найти запчасти для моей техники",
        q1h: "напр. CAT 320, Komatsu PC200",
        q2: "Узнать цены",
        q2h: "Коммерческие условия и наличие",
        q3: "Как получить расчёт?",
        q3h: "Быстрый ответ отдела продаж",
        hi: "Здравствуйте, я ваш эксперт по запчастям.",
        hiSub:
          "Назовите бренд и модель техники — я подберу нужные детали и помогу с расчётом цены.",
        placeholder: "напр. Цепь для CAT D6D…",
        nowShowing: "Открыта страница:",
      },
    },
  },
  ar: {
    translation: {
      nav: {
        quote: "عرض سعر",
        brands: "الماركات",
        search: "بحث_القطع",
        company: "الشركة",
        searchPlaceholder: "ابحث: ماركة / موديل / قطعة_",
        insights: "معلومات الشركة ورؤاها",
      },
      footer: {
        blurb:
          "<0>VANROCK Track Solutions</0> جزء من <1>VANROCK Group</1> — مجموعة عالمية تُصنّع أنظمة الهيكل السفلي للحفارات والحفارات الصغيرة والجرافات واللوادر لأكثر من 270 ماركة معدات.",
        visitGlobal: "زوروا موقعنا العالمي — vanrockglobal.com ↗",
        tagline: "قطع هيكل سفلي فاخرة. مصنوعة لتدوم.",
        catalog: "الكتالوج",
        company: "الشركة",
        contact: "اتصل بنا",
        allBrands: "جميع الماركات",
        partSearch: "بحث القطع",
        becomeDealer: "كن وكيلاً ←",
        rights: "جميع الحقوق محفوظة",
        admin: "دخول_الإدارة",
      },
      home: {
        kicker: "شركة",
        kickerCompany: "",
        h1a: "اعثر على قطعة",
        h1b: "الهيكل السفلي",
        h1c: "المطلوبة.",
        heroSub:
          "بكرات سفلية وعلوية، قطاعات الجنزير المسنن، جنازير، بلاطات، براغي وصواميل — تغطي {{brands}} ماركة و{{models}} موديل معدات.",
        searchBtn: "بحث",
        try: "جرّب:",
        statBrands: "ماركة",
        statModels: "موديل",
        statParts: "قطعة",
        browseKicker: "تصفح_الكتالوج",
        brandIndex: "فهرس الماركات",
        allN: "الكل {{n}} ←",
        modelsWord: "موديل",
        topBrands: "العلامات الأكثر فهرسة",
        azBrands: "جميع العلامات أ–ي",
        compKicker: "المكوّنات",
        compTitle: "كل مكوّنات الهيكل السفلي",
        f1t: "مواصفات OEM",
        f1x: "فولاذ البورون والسبائك، أسطح تآكل مقسّاة بعمق، مختومة ومشحّمة مدى الحياة.",
        f2t: "شحن سريع لجميع أنحاء العالم",
        f2x: "القطع تُشحن من المخزون. عرض الشحن مشمول مع كل عرض سعر.",
        f3t: "دعم فني مجاني",
        f3x: "أرسل لنا الرقم التسلسلي لمعداتك وسيحدد خبراؤنا القطعة المطابقة تماماً.",
        dealerKicker: "برنامج_الوكلاء",
        dealerT1: "ضع",
        dealerT2: "على رفوفك.",
        dealerSub:
          "جودة ثابتة، مخزون عميق وأسعار مباشرة من المصنع — كل ما يحتاجه الوكيل للفوز بسوقه. انضم إلى شبكة وكلاء VANROCK في منطقتك.",
        dp1: "+ أسعار مباشرة من المصنع",
        dp2: "+ حماية المنطقة",
        dp3: "+ دعم تسويقي",
        dp4: "+ أولوية تخصيص المخزون",
        dealerCta: "كن وكيلاً ←",
        faqKicker: "الأسئلة الشائعة",
        faqTitle: "الأسئلة الأكثر شيوعاً",
        faq1q: "ما هي ماركات المعدات التي تغطونها؟",
        faq1a:
          "نوفر قطع الهيكل السفلي لأكثر من 270 ماركة منها Caterpillar وKomatsu وKobelco وHitachi وVolvo وJCB وHyundai وDoosan وCase وLiebherr وTakeuchi وYanmar وKubota وغيرها الكثير.",
        faq2q: "كيف أجد قطعاً لمعداتي؟",
        faq2a:
          "اختر ماركة معداتك ثم اختر الموديل الدقيق من القائمة الأبجدية. تعرض صفحة كل موديل جميع مكوّنات الهيكل السفلي المتاحة: البكرات، قطاعات الجنزير المسنن، الجنازير، البلاطات، البراغي والصواميل.",
        faq3q: "كيف أحصل على الأسعار؟",
        faq3a:
          "افتح صفحة أي قطعة وأرسل نموذج طلب عرض السعر. يرد فريقنا خلال يوم عمل واحد بالسعر والتوفر.",
        faq4q: "هل القطع بجودة OEM؟",
        faq4a:
          "جميع القطع مُصنّعة وفق مواصفات OEM من فولاذ البورون والسبائك، بأسطح تآكل مقسّاة بعمق وتجميعات مختومة ومشحّمة مدى الحياة حيثما ينطبق.",
      },
      company: {
        h1a: "صُنعت لأقسى",
        h1b: "أراضي العالم.",
        heroSub:
          "VANROCK Track Solutions هي قسم الهيكل السفلي في VANROCK Group — نُهندس ونطرق ونُشغّل أنظمة الجنازير لأشهر ماركات المعدات في العالم، ونورّد للوكلاء والأساطيل حول العالم.",
        visitGlobal: "زوروا موقعنا العالمي ↗",
        s1: "ماركة معدات مغطاة",
        s2: "قطعة مُهندَسة ومفهرسة",
        s3: "موديل معدات مدعوم",
        s4: "فحص جودة قبل الشحن",
        madeKicker: "صنع_في_VANROCK",
        madeT1: "جميع القطع مصنوعة 100% في",
        madeT2: "مصنع VANROCK الخاص.",
        madeT3: "بدون تعهيد خارجي.",
        madeSub:
          "من فولاذ البورون الخام إلى المكوّن النهائي، تتم العملية بأكملها تحت سقف واحد — فالجودة تُراقَب في كل خطوة، ولا تُترك وعوداً لدى المورّدين.",
        mp1: "طرق وتشغيل ومعالجة حرارية داخلية",
        mp2: "فحص جودة 100% قبل الشحن",
        mp3: "مواد بمواصفات OEM قابلة للتتبع",
        mp4: "أسعار مباشرة من المصنع — بلا وسطاء",
        whKicker: "المستودع_العالمي",
        whT1: "مخزون عميق.",
        whT2: "شحن سريع.",
        whSub:
          "آلاف البكرات والعجلات الموجهة والجنازير والبلاطات على الرفوف دائماً — جاهزة للشحن عالمياً فور تأكيد طلبك.",
        mapKicker: "الحضور_العالمي",
        mapTitle: "ماركة واحدة. كل القارات.",
        mapDesc: "تعمل VANROCK من خلال أربعة مكاتب إقليمية في ميونخ وفورت وورث وداندينونغ ولوديانا — لدعم الموزعين في أوروبا وأمريكا الشمالية وأستراليا وآسيا بجهات اتصال محلية ومناطق زمنية محلية وشبكة مخزون مشتركة.",
        mapSub:
          "قطع VANROCK تعمل على معدات في مواقع الإنشاء والتعدين حول العالم — عبر شبكة وكلائنا والتصدير المباشر.",
        ms1: "دولة نخدمها",
        ms2: "قارات",
        ms3: "رد على طلبات الأسعار",
        ms4: "شحن عالمي",
        galKicker: "داخل_VANROCK",
        galTitle: "الإنتاج والمستودعات",
        teamKicker: "فريقنا",
        teamTitle: "فريق واحد. معيار واحد.",
        teamSub: "خلف كل مكوّن من مكوّنات VANROCK فريق من المهندسين وأخصائيي الإنتاج ودعم الموزعين يعمل وفق المعيار نفسه — في المصنع وفي الميدان.",
        factsTitle: "حقائق وأرقام",
        scroll: "← مرّر",
      },
      dealer: {
        heroT1: "كن",
        heroT2: "وكيلاً.",
        heroSub:
          "تُباع جنازير VANROCK وبلاطاتها وبكراتها وعجلاتها الموجهة وترسها المسنن عبر شبكة وكلاء محمية. إذا كنت توزّع قطع الهيكل السفلي في سوقك، فهذا البرنامج صُمم لك.",
        b1t: "أسعار مباشرة من المصنع",
        b1x: "اشترِ مباشرة من VANROCK — بلا وسطاء وبلا هوامش. يشتري الوكلاء بأسعار المصنع الحقيقية.",
        b2t: "حماية المنطقة",
        b2x: "نحدّ من عدد الوكلاء في كل منطقة حتى يبقى استثمارك في علامة VANROCK محمياً.",
        b3t: "أولوية تخصيص المخزون",
        b3x: "يحصل الوكلاء أولاً على دفعات الإنتاج والمخزون المحجوز للقطع سريعة الحركة.",
        b4t: "دعم تسويقي",
        b4x: "كتالوجات مشتركة، أوراق بيانات المنتجات، صور احترافية ودعم إطلاق لسوقك المحلي.",
        b5t: "شحن مجمّع",
        b5x: "حاويات كاملة وتجميع قطع مختلطة من مستودعنا مع إنجاز مستندات التصدير عنك.",
        b6t: "شبكة عالمية",
        b6x: "انضم إلى وكلاء في أسواق الإنشاء والتعدين بدعم من مجموعة VANROCK Group.",
        howKicker: "كيف_يعمل",
        howTitle: "من التقديم إلى أول شحنة",
        st1t: "قدّم",
        st1x: "املأ نموذج التسجيل أدناه ببيانات شركتك والمنطقة المستهدفة.",
        st2t: "المراجعة",
        st2x: "يراجع فريق الوكلاء طلبك وملاءمة السوق — عادةً خلال يومي عمل.",
        st3t: "الاتفاقية",
        st3x: "نتفق معاً على المنطقة وفئة الأسعار وأول طلب مخزون مع مديرك المخصص.",
        st4t: "الانطلاق",
        st4x: "تستلم الكتالوجات والمواد التسويقية وشحنتك الأولى — وتبدأ ببيع VANROCK.",
        regKicker: "التسجيل",
        regTitle: "تسجيل الوكلاء",
        regSub: "الحقول المعلّمة بـ * إلزامية. يرد فريق الوكلاء خلال يومي عمل.",
        lCompany: "اسم الشركة *",
        lContact: "الشخص المسؤول *",
        lEmail: "البريد الإلكتروني *",
        lPhone: "الهاتف *",
        lCountry: "الدولة *",
        lCity: "المدينة / المنطقة",
        lWebsite: "موقع الشركة",
        lType: "نوع النشاط",
        lYears: "سنوات الخبرة",
        lVolume: "حجم الشراء الشهري المتوقع",
        lBrands: "ماركات المعدات التي تخدمها",
        lMessage: "حدثنا عن سوقك",
        selectCountry: "اختر الدولة…",
        select: "اختر…",
        submit: "أرسل الطلب ←",
        submitting: "جارٍ الإرسال…",
        okTitle: "تم استلام الطلب.",
        okText:
          "شكراً لك. سيراجع فريق الوكلاء طلبك الخاص بـ {{country}} وسيتواصل معك على {{email}} خلال يومي عمل.",
      },
      chat: {
        teaser:
          "تحتاج مساعدة في إيجاد القطعة الصحيحة؟ اسألني — أعرف أكثر من 48,000 قطعة.",
        status: "متصل — يرد خلال ثوانٍ",
        headerStatus: "خبير قطع الغيار — يرد خلال ثوانٍ",
        q1: "ابحث عن قطع لمعداتي",
        q1h: "مثال: CAT 320، Komatsu PC200",
        q2: "اسأل عن الأسعار",
        q2h: "الشروط التجارية والتوفر",
        q3: "كيف أحصل على عرض سعر؟",
        q3h: "رد سريع من فريق المبيعات",
        hi: "مرحباً، أنا خبير قطع الغيار.",
        hiSub:
          "أخبرني بماركة وموديل معداتك — سأجد القطع الصحيحة وأساعدك في الحصول على عرض سعر.",
        placeholder: "مثال: جنزير لـ CAT D6D…",
        nowShowing: "المعروض الآن:",
      },
    },
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: "en",
    fallbackLng: "en",
    supportedLngs: ["en", "es", "it", "de", "pt", "fr", "nl", "ru", "lt"],
    interpolation: { escapeValue: false },
  });

Object.entries(CATALOG).forEach(([lng, cat]) => {
  i18n.addResourceBundle(lng, "translation", { cat }, true, true);
});
Object.entries(SEOI18N).forEach(([lng, seo]) => {
  i18n.addResourceBundle(lng, "translation", { seo }, true, true);
});
Object.entries(PAGES_EXTRA).forEach(([lng, d]) => {
  i18n.addResourceBundle(lng, "translation", d, true, true);
});
Object.entries(DEALER_I18N).forEach(([lng, d]) => {
  i18n.addResourceBundle(lng, "translation", d, true, true);
});
Object.entries(QA_FOOTER_EXTRA).forEach(([lng, d]) => {
  i18n.addResourceBundle(lng, "translation", d, true, true);
});
Object.entries({
  en: LEGAL_EN,
  es: LEGAL_ES,
  it: LEGAL_IT,
  de: LEGAL_DE,
  pt: LEGAL_PT,
  fr: LEGAL_FR,
  nl: LEGAL_NL,
  ru: LEGAL_RU,
  lt: LEGAL_LT,
}).forEach(([lng, d]) => {
  i18n.addResourceBundle(lng, "translation", d, true, true);
});
i18n.addResourceBundle("fr", "translation", FR_EXTRA, true, true);
i18n.addResourceBundle("nl", "translation", NL_EXTRA, true, true);
i18n.addResourceBundle("ru", "translation", RU_EXTRA, true, true);
i18n.addResourceBundle("lt", "translation", LT_EXTRA, true, true);
Object.entries(CORPORATE).forEach(([lng, d]) => {
  i18n.addResourceBundle(lng, "translation", d, true, true);
});
const applyDir = (lng) => {
  document.documentElement.lang = lng;
  document.documentElement.dir = RTL_LANGS.includes((lng || "en").slice(0, 2))
    ? "rtl"
    : "ltr";
};
i18n.on("languageChanged", applyDir);
applyDir(i18n.language?.slice(0, 2) || "en");

export default i18n;
